'use strict';

/*
 엔트리에 정의된 블럭 명령어
 엔트리에서 받을 때는 BlockTypes 로 통신하고,
 하드웨어로 전송할 때는 Command 로 변환 후 Pdu 로 Wrapping 하여 전송한다.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NeoBlockType = {
  // MOTOR 명령어 0x1X
  MOTOR_MOVE: 0x11,
  MOTOR_MOVE_BOTH: 0x12,
  MOTOR_STOP: 0x13,
  ROBOT_MOVE: 0x14,
  ROBOT_STOP: 0x15,
  // SERVO 명령어 0x2X
  SERVO_RESET: 0x21,
  SERVO_ANGLE: 0x22,
  SERVO_ANGLE_WAIT: 0x23,
  SERVO_ROTATE: 0x24,
  SERVO_STOP: 0x25,
  // LINE_TRACER 명령어 0x3X
  LINE_TRACER_START: 0x31,
  LINE_CROSS_MOVE: 0x32,
  LINE_CROSS_TURN: 0x33,
  LINE_CHANGE_START: 0x34,
  LINE_CHANGE_TURN: 0x35,
  // AUTO_DRIVING 명령어 0x4X
  AUTO_DRIVING_START: 0x41,
  AUTO_DRIVING_SENSOR_START: 0x42,
  AUTO_DRIVING_STOP: 0x43,
  AUTO_PARKING_START: 0x44,
  AUTO_DETECT_WALL_START: 0x45,
  AUTO_DETECT_WALL_TURN: 0x46,
  // LED 명령어 0x5X
  LED_ON: 0x51,
  LED_BLINK: 0x52,
  LED_OFF: 0x53,
  COLOR_LED_ON: 0x54,
  COLOR_LED_OFF: 0x55,
  COLOR_LED_ON_SENSOR: 0x56,
  // SET_OUTPUT 명령어 0x6X
  SET_OUTPUT: 0x61,
  // BUZZER 명령어 0x7X
  BUZZER_START: 0x71,
  BUZZER_WITH_SENSOR: 0x72,
  BUZZER_STOP: 0x73,
  // LCD 명령어 0x8X
  LCD_IMAGE: 0x81,
  LCD_TEXT: 0x82
};

/*
 PDU 정의
 */
var HEADER = [0xaa, 0xaa, 0xcc];
var FrameCode = {
  BASIC: 0x01
};
var PduCode = {
  SENSOR_DATA: 0x01,
  CONTROLLER_COMMAND: 0x02,
  ACTION_COMMAND: 0x03,
  BASIC: 0x10,
  EXTEND_1: 0x11,
  EXTEND_2: 0x12,
  EXTEND_3: 0x13
};
var ActorKind = {
  CONTROLLER: 0x00,
  LED: 0x80,
  SERVO: 0x81,
  COLOR_LED: 0x82,
  LCD: 0x83
};
var ControllerCommand = {
  CONTROLLER_LED: 0x01,
  BUZZER: 0x02,
  MOTOR: 0x03,
  MOTOR_BOTH: 0x04,
  ROBOT: 0x05,
  LINE_TRACER: 0x06,
  AUTO_DRIVING: 0x07,
  AUTO_PARKING: 0x08,
  AUTO_DETECT_WALL: 0x09
};
var ServoCommand = {
  STOP: 0x01,
  RESET: 0x02,
  ANGLE: 0x03,
  ANGLE_WAIT: 0x04,
  ROTATE: 0x05
};
var LedCommand = {
  OFF: 0x00,
  ON: 0x01
};
var LcdCommand = {
  IMAGE: 0x01,
  TEXT: 0x02
};
var UnitId = {
  CONTROLLER: 0x00,
  CONTROLLER_IN1: 0x01,
  CONTROLLER_IN2: 0x02,
  CONTROLLER_IN3: 0x03,
  SENSOR_STICK: 0x10,
  SENSOR_STICK_IN1: 0x11,
  IOT: 0x80,
  CONTROLLER_OUT1: 0x81,
  CONTROLLER_OUT2: 0x82,
  CONTROLLER_OUT12: 0x83,
  CONTROLLER_OUT3: 0x84,
  CONTROLLER_OUT13: 0x85,
  CONTROLLER_OUT23: 0x86,
  CONTROLLER_OUT123: 0x87,
  CONTROLLER_OUT_ALL: 0x8f
};

/*
 블럭 실행 단계
 execute: 최초 실행
 pending_response: 최초 실행의 response 대기중인 상태
 set_timeout: 블럭에서 duration 필드에 의거하여 타임아웃을 설정
 wait_timeout: timeout 대기중인 상태
 stop: 파라미터를 0으로 바꿔서 실행
 pending_stop: 파라미터를 0으로 바꾼 실행의 response 대기중인 상태
 end: 실행 종료 단계
 */
var ExecPhase = {
  EXECUTE: 'execute',
  PENDING_RESPONSE: 'pending_response',
  SET_TIMEOUT: 'set_timeout',
  WAIT_TIMEOUT: 'wait_timeout',
  STOP: 'stop',
  PENDING_STOP: 'pending_stop',
  END: 'end'
};

/*
 dropdown params
 양이 많아서 분리함.
 */
Entry.Neo = new (/*#__PURE__*/function () {
  function Neo() {
    (0, _classCallCheck2["default"])(this, Neo);
    this.id = '5.8';
    this.url = 'http://www.neobot.co.kr';
    this.name = 'neo';
    this.imageName = 'neo.png';
    this.title = {
      ko: '네오(NEO)',
      en: 'NEO'
    };
    this.blockMenuBlocks = [
    // robot
    'neo_robot_title', 'neo_robot_move', 'neo_robot_stop',
    // auto driving
    'neo_auto_driving_title', 'neo_auto_driving_start', 'neo_auto_driving_sensor_start', 'neo_auto_driving_stop',
    // auto parking
    // 'neo_auto_parking_title',
    // 'neo_auto_parking_start',

    // line tracer
    // 'neo_line_tracer_title',
    'neo_line_tracer_start', 'neo_line_cross_move', 'neo_line_cross_turn', 'neo_line_cross_reached',
    // motor
    'neo_motor_title', 'neo_motor_move', 'neo_motor_move_both', 'neo_motor_stop',
    // servo
    'neo_servo_title', 'neo_servo_reset', 'neo_servo_angle', 'neo_servo_angle_var', 'neo_servo_angle_wait', 'neo_servo_rotate', 'neo_servo_stop',
    // led
    'neo_led_title', 'neo_led_on', 'neo_led_blink', 'neo_led_off',
    // set output
    'neo_set_output_title', 'neo_set_output',
    // color led
    'neo_color_led_title', 'neo_color_led_on', 'neo_color_led_off', 'neo_color_led_on_with_sensor',
    // sensor
    'neo_sensor_title', 'neo_sensor_in', 'neo_sensor_digital_in', 'neo_sensor_convert', 'neo_sensor_compare', 'neo_sensor_between', 'neo_sensor_digital_compare', 'neo_sensor_color_compare', 'neo_sensor_color_sequence_compare', 'neo_sensor_button_pressed',
    // buzzer
    'neo_buzzer_title', 'neo_buzzer_start', 'neo_buzzer_with_sensor', 'neo_buzzer_stop',
    // lcd
    'neo_lcd_title', 'neo_lcd_image', 'neo_lcd_text'];
    this.seqBlockId = 0;
    this.executeList = {};
    this.pendingResponseList = {};
    this.monitorTemplate = {
      imgPath: 'hw/neo.png',
      width: 500,
      height: 500,
      listPorts: {
        IN11: {
          name: 'IN1 1',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN12: {
          name: 'IN1 2',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN13: {
          name: 'IN1 3',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN14: {
          name: 'IN1 4',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN21: {
          name: 'IN2 1',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN22: {
          name: 'IN2 2',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN23: {
          name: 'IN2 3',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN24: {
          name: 'IN2 4',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN31: {
          name: 'IN3 1',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN32: {
          name: 'IN3 2',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN33: {
          name: 'IN3 3',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IN34: {
          name: 'IN3 4',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        IR: {
          name: 'IR',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        },
        BAT: {
          name: 'BAT',
          type: 'input',
          pos: {
            x: 0,
            y: 0
          }
        }
      },
      mode: 'both'
    };
  }
  return (0, _createClass2["default"])(Neo, [{
    key: "setZero",
    value: function setZero() {
      var blockId = this.generateBlockId();
      var pdu = this.makePdu([FrameCode.BASIC, PduCode.CONTROLLER_COMMAND, blockId, 0x04]);
      Entry.hw.sendQueue.executeList = {
        blockId: {
          blockId: blockId,
          pdu: pdu
        }
      };
      Entry.hw.update();
      this.pendingResponseList = {};
      this.executeList = {};
    }
  }, {
    key: "afterReceive",
    value: function afterReceive(portData) {
      for (var i = 0; i <= 255; i++) {
        if (this.pendingResponseList[i]) {
          if (portData.pendingList[i] && portData.pendingList[i].state === 'completed') {
            delete this.pendingResponseList[i];
            delete this.executeList[i];
          }
        }
      }
    }
  }, {
    key: "generateBlockId",
    value: function generateBlockId() {
      this.seqBlockId += 1;
      if (this.seqBlockId > 255) {
        this.seqBlockId = 1;
      }
      return this.seqBlockId;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage() {
      return {
        ko: {
          template: {
            // robot
            neo_robot_title: '로봇',
            neo_robot_move: '로봇 제어하기 %1 %2 %3 %4',
            neo_robot_stop: '로봇 멈추기 %1',
            // auto driving
            neo_auto_driving_title: '자율주행',
            neo_auto_driving_start: '자율주행 시작하기 %1 %2 %3',
            neo_auto_driving_sensor_start: '%1 를 감지하여 자율주행 %2 %3',
            neo_auto_driving_stop: '자율주행 멈추기 %1',
            // auto parking
            neo_auto_parking_title: '자율주차 | 아이블(AiBle) 전용',
            neo_auto_parking_start: '주차하기 %1 %2 %3',
            // line tracer
            neo_line_tracer_title: '라인트레이서 | 아이온(AION) 전용',
            neo_line_tracer_start: '검은색 길 따라가기 %1 %2 %3',
            neo_line_cross_move: '%1 교차로까지 직진하기 %2',
            neo_line_cross_turn: '방향바꾸기 %1 %2',
            neo_line_cross_reached: '교차로에 도착하였는가?',
            // motor
            neo_motor_title: '회전모터',
            neo_motor_move: '회전모터 제어하기 %1 %2 %3 %4',
            neo_motor_move_both: '회전모터 동시에 제어하기 L %1 R %2 %3',
            neo_motor_stop: '회전모터 멈추기 %1 %2',
            // servo
            neo_servo_title: '서보모터',
            neo_servo_reset: '%1 서보모터 현위치를 0도로 설정하기 %2',
            neo_servo_angle: '서보모터 각도 바꾸기 %1 %2 %3 %4',
            neo_servo_angle_var: '서보모터 각도 바꾸기 %1 %2 %3 %4',
            neo_servo_angle_wait: '각도 바뀔때까지 기다리기 %1 %2 %3 %4',
            neo_servo_rotate: '서보모터 회전하기 %1 %2 %3 %4',
            neo_servo_stop: '서보모터 멈추기 %1 %2',
            // led
            neo_led_title: 'LED',
            neo_led_on: 'LED 켜기 %1 %2 %3 %4',
            neo_led_blink: 'LED 깜빡이기 %1 %2 %3 %4',
            neo_led_off: 'LED 끄기 %1 %2',
            // set output
            neo_set_output_title: '출력',
            neo_set_output: '값 출력하기 %1 %2 %3 %4',
            // color led
            neo_color_led_title: '컬러 LED',
            neo_color_led_on: '컬러LED 켜기 %1 %2 %3 %4',
            neo_color_led_off: '컬러LED 끄기 %1 %2',
            neo_color_led_on_with_sensor: '컬러센서 %1 로 컬러LED %2 제어 %3',
            // sensor
            neo_sensor_title: '센서',
            neo_sensor_in: '%1',
            neo_sensor_in_2: '%1',
            neo_sensor_digital_in: '%1 의 %2',
            neo_sensor_convert: '%1 : %2 %3 → %4 %5',
            neo_sensor_compare: '%1 %2 %3',
            neo_sensor_between: '%1 %2 %3 %4 %5',
            neo_sensor_digital_compare: '%1 의 %2 %3 %4',
            neo_sensor_color_compare: '%1 = %2',
            neo_sensor_color_sequence_compare: '%1 = %2 %3 %4',
            neo_sensor_button_pressed: '%1 %2',
            // buzzer
            neo_buzzer_title: '버저',
            neo_buzzer_start: '버저 울리기 %1 %2 %3 %4',
            neo_buzzer_with_sensor: '센서로 버저 울리기 %1 %2',
            neo_buzzer_stop: '버저 멈추기 %1',
            // lcd
            neo_lcd_title: 'LCD',
            neo_lcd_image: 'LCD에 이미지 보여주기 %1 %2 %3',
            neo_lcd_text: 'LCD에 텍스트 보여주기 %1 %2 %3',
            // args
            neo_arg_duration: '%1',
            neo_arg_both_motor_speed: '%1',
            neo_arg_servo_angle: '%1'
          },
          Blocks: {
            neo_input_1: 'IN1',
            neo_input_2: 'IN2',
            neo_input_3: 'IN3',
            neo_input_12: 'IN1&2',
            neo_input_123: 'IN1&2&3',
            neo_input_1_2: 'IN1&IN2',
            neo_input_11_12: 'IN1-1&IN1-2',
            neo_input_13_14: 'IN1-3&IN1-4',
            neo_input_21_22: 'IN2-1&IN2-2',
            neo_input_23_24: 'IN2-3&IN2-4',
            neo_input_31_32: 'IN3-1&IN3-2',
            neo_input_33_34: 'IN3-3&IN3-4',
            neo_output_1: 'OUT1',
            neo_output_2: 'OUT2',
            neo_output_3: 'OUT3',
            neo_output_12: 'OUT1&2',
            neo_output_123: 'OUT1&2&3',
            neo_speed_0: '0%',
            neo_speed_5: '5%',
            neo_speed_10: '10%',
            neo_speed_15: '15%',
            neo_speed_20: '20%',
            neo_speed_25: '25%',
            neo_speed_30: '30%',
            neo_speed_35: '35%',
            neo_speed_40: '40%',
            neo_speed_45: '45%',
            neo_speed_50: '50%',
            neo_speed_55: '55%',
            neo_speed_60: '60%',
            neo_speed_65: '65%',
            neo_speed_70: '70%',
            neo_speed_75: '75%',
            neo_speed_80: '80%',
            neo_speed_85: '85%',
            neo_speed_90: '90%',
            neo_speed_95: '95%',
            neo_speed_100: '100%',
            neo_duration_c: '계속',
            neo_duration_0: '0초',
            neo_duration_1: '1초',
            neo_duration_2: '2초',
            neo_duration_3: '3초',
            neo_duration_4: '4초',
            neo_duration_5: '5초',
            neo_duration_6: '6초',
            neo_duration_7: '7초',
            neo_duration_8: '8초',
            neo_duration_9: '9초',
            neo_compare_gt: '≥',
            neo_compare_g: '>',
            neo_compare_e: '=',
            neo_compare_l: '<',
            neo_compare_lt: '≤',
            neo_turn_direction_l: '좌회전',
            neo_turn_direction_r: '우회전',
            neo_turn_direction_u: 'U턴',
            neo_motor_out_l: 'L모터',
            neo_motor_out_r: 'R모터',
            neo_motor_out_lr: 'L/R모터',
            neo_motor_speed_n100: '-100%',
            neo_motor_speed_n95: '-95%',
            neo_motor_speed_n90: '-90%',
            neo_motor_speed_n85: '-85%',
            neo_motor_speed_n80: '-80%',
            neo_motor_speed_n75: '-75%',
            neo_motor_speed_n70: '-70%',
            neo_motor_speed_n65: '-65%',
            neo_motor_speed_n60: '-60%',
            neo_motor_speed_n55: '-55%',
            neo_motor_speed_n50: '-50%',
            neo_motor_speed_n45: '-45%',
            neo_motor_speed_n40: '-40%',
            neo_motor_speed_n35: '-35%',
            neo_motor_speed_n30: '-30%',
            neo_motor_speed_n25: '-25%',
            neo_motor_speed_n20: '-20%',
            neo_motor_speed_n15: '-15%',
            neo_motor_speed_n10: '-10%',
            neo_motor_speed_n5: '-5%',
            neo_motor_speed_0: '0%',
            neo_motor_speed_5: '5%',
            neo_motor_speed_10: '10%',
            neo_motor_speed_15: '15%',
            neo_motor_speed_20: '20%',
            neo_motor_speed_25: '25%',
            neo_motor_speed_30: '30%',
            neo_motor_speed_35: '35%',
            neo_motor_speed_40: '40%',
            neo_motor_speed_45: '45%',
            neo_motor_speed_50: '50%',
            neo_motor_speed_55: '55%',
            neo_motor_speed_60: '60%',
            neo_motor_speed_65: '65%',
            neo_motor_speed_70: '70%',
            neo_motor_speed_75: '75%',
            neo_motor_speed_80: '80%',
            neo_motor_speed_85: '85%',
            neo_motor_speed_90: '90%',
            neo_motor_speed_95: '95%',
            neo_motor_speed_100: '100%',
            neo_robot_direction_f: '앞으로',
            neo_robot_direction_b: '뒤로',
            neo_robot_direction_l: '왼쪽으로',
            neo_robot_direction_r: '오른쪽으로',
            neo_robot_direction_tl: '제자리왼쪽',
            neo_robot_direction_tr: '제자리오른쪽',
            neo_servo_angle_n360: '-360도',
            neo_servo_angle_n350: '-350도',
            neo_servo_angle_n340: '-340도',
            neo_servo_angle_n330: '-330도',
            neo_servo_angle_n320: '-320도',
            neo_servo_angle_n310: '-310도',
            neo_servo_angle_n300: '-300도',
            neo_servo_angle_n290: '-290도',
            neo_servo_angle_n280: '-280도',
            neo_servo_angle_n270: '-270도',
            neo_servo_angle_n260: '-260도',
            neo_servo_angle_n250: '-250도',
            neo_servo_angle_n240: '-240도',
            neo_servo_angle_n230: '-230도',
            neo_servo_angle_n220: '-220도',
            neo_servo_angle_n210: '-210도',
            neo_servo_angle_n200: '-200도',
            neo_servo_angle_n190: '-190도',
            neo_servo_angle_n180: '-180도',
            neo_servo_angle_n170: '-170도',
            neo_servo_angle_n160: '-160도',
            neo_servo_angle_n150: '-150도',
            neo_servo_angle_n140: '-140도',
            neo_servo_angle_n130: '-130도',
            neo_servo_angle_n120: '-120도',
            neo_servo_angle_n110: '-110도',
            neo_servo_angle_n100: '-100도',
            neo_servo_angle_n90: '-90도',
            neo_servo_angle_n80: '-80도',
            neo_servo_angle_n70: '-70도',
            neo_servo_angle_n60: '-60도',
            neo_servo_angle_n50: '-50도',
            neo_servo_angle_n40: '-40도',
            neo_servo_angle_n30: '-30도',
            neo_servo_angle_n20: '-20도',
            neo_servo_angle_n10: '-10도',
            neo_servo_angle_0: '0도',
            neo_servo_angle_10: '10도',
            neo_servo_angle_20: '20도',
            neo_servo_angle_30: '30도',
            neo_servo_angle_40: '40도',
            neo_servo_angle_50: '50도',
            neo_servo_angle_60: '60도',
            neo_servo_angle_70: '70도',
            neo_servo_angle_80: '80도',
            neo_servo_angle_90: '90도',
            neo_servo_angle_100: '100도',
            neo_servo_angle_110: '110도',
            neo_servo_angle_120: '120도',
            neo_servo_angle_130: '130도',
            neo_servo_angle_140: '140도',
            neo_servo_angle_150: '150도',
            neo_servo_angle_160: '160도',
            neo_servo_angle_170: '170도',
            neo_servo_angle_180: '180도',
            neo_servo_angle_190: '190도',
            neo_servo_angle_200: '200도',
            neo_servo_angle_210: '210도',
            neo_servo_angle_220: '220도',
            neo_servo_angle_230: '230도',
            neo_servo_angle_240: '240도',
            neo_servo_angle_250: '250도',
            neo_servo_angle_260: '260도',
            neo_servo_angle_270: '270도',
            neo_servo_angle_280: '280도',
            neo_servo_angle_290: '290도',
            neo_servo_angle_300: '300도',
            neo_servo_angle_310: '310도',
            neo_servo_angle_320: '320도',
            neo_servo_angle_330: '330도',
            neo_servo_angle_340: '340도',
            neo_servo_angle_350: '350도',
            neo_servo_angle_360: '360도',
            neo_servo_direction_f: '앞으로',
            neo_servo_direction_b: '뒤로',
            neo_line_cross_move_1: '첫번째',
            neo_line_cross_move_2: '두번째',
            neo_line_cross_move_3: '세번째',
            neo_line_cross_move_4: '네번째',
            neo_line_cross_move_5: '다섯번째',
            neo_line_cross_move_6: '여섯번째',
            neo_line_cross_move_7: '일곱번째',
            neo_line_cross_move_8: '여덟번째',
            neo_line_cross_move_9: '아홉번째',
            neo_line_cross_move_10: '열번째',
            neo_line_cross_turn_direction_l: '좌회전',
            neo_line_cross_turn_direction_r: '우회전',
            neo_line_cross_turn_direction_u: 'U턴',
            neo_line_cross_turn_which_next: '다음',
            neo_line_cross_turn_which_current: '현재',
            neo_auto_driving_speed_in3: 'IN3',
            neo_auto_parking_which_l: '왼쪽에',
            neo_auto_parking_which_r: '오른쪽에',
            neo_auto_parking_direction_b: '후면주차',
            neo_auto_parking_direction_s: '평행주차',
            neo_led_brightness_0: '0%',
            neo_led_brightness_5: '5%',
            neo_led_brightness_10: '10%',
            neo_led_brightness_15: '15%',
            neo_led_brightness_20: '20%',
            neo_led_brightness_25: '25%',
            neo_led_brightness_30: '30%',
            neo_led_brightness_35: '35%',
            neo_led_brightness_40: '40%',
            neo_led_brightness_45: '45%',
            neo_led_brightness_50: '50%',
            neo_led_brightness_55: '55%',
            neo_led_brightness_60: '60%',
            neo_led_brightness_65: '65%',
            neo_led_brightness_70: '70%',
            neo_led_brightness_75: '75%',
            neo_led_brightness_80: '80%',
            neo_led_brightness_85: '85%',
            neo_led_brightness_90: '90%',
            neo_led_brightness_95: '95%',
            neo_led_brightness_100: '100%',
            neo_led_blink_speed_1: '1단계',
            neo_led_blink_speed_2: '2단계',
            neo_led_blink_speed_3: '3단계',
            neo_led_blink_speed_4: '4단계',
            neo_led_blink_speed_5: '5단계',
            neo_set_output_value_0: '0',
            neo_set_output_value_5: '5',
            neo_set_output_value_10: '10',
            neo_set_output_value_15: '15',
            neo_set_output_value_20: '20',
            neo_set_output_value_25: '25',
            neo_set_output_value_30: '30',
            neo_set_output_value_35: '35',
            neo_set_output_value_40: '40',
            neo_set_output_value_45: '45',
            neo_set_output_value_50: '50',
            neo_set_output_value_55: '55',
            neo_set_output_value_60: '60',
            neo_set_output_value_65: '65',
            neo_set_output_value_70: '70',
            neo_set_output_value_75: '75',
            neo_set_output_value_80: '80',
            neo_set_output_value_85: '85',
            neo_set_output_value_90: '90',
            neo_set_output_value_95: '95',
            neo_set_output_value_100: '100',
            neo_set_output_value_105: '105',
            neo_set_output_value_110: '110',
            neo_set_output_value_115: '115',
            neo_set_output_value_120: '120',
            neo_set_output_value_125: '125',
            neo_set_output_value_130: '130',
            neo_set_output_value_135: '135',
            neo_set_output_value_140: '140',
            neo_set_output_value_145: '145',
            neo_set_output_value_150: '150',
            neo_set_output_value_155: '155',
            neo_set_output_value_160: '160',
            neo_set_output_value_165: '165',
            neo_set_output_value_170: '170',
            neo_set_output_value_175: '175',
            neo_set_output_value_180: '180',
            neo_set_output_value_185: '185',
            neo_set_output_value_190: '190',
            neo_set_output_value_195: '195',
            neo_set_output_value_200: '200',
            neo_set_output_value_205: '205',
            neo_set_output_value_210: '210',
            neo_set_output_value_215: '215',
            neo_set_output_value_220: '220',
            neo_set_output_value_225: '225',
            neo_set_output_value_230: '230',
            neo_set_output_value_235: '235',
            neo_set_output_value_240: '240',
            neo_set_output_value_245: '245',
            neo_set_output_value_250: '250',
            neo_set_output_value_255: '255',
            neo_sensor_in_digital_1: '1번',
            neo_sensor_in_digital_2: '2번',
            neo_sensor_in_digital_3: '3번',
            neo_sensor_in_digital_4: '4번',
            neo_color_black: '검정',
            neo_color_white: '흰색',
            neo_color_red: '빨강',
            neo_color_yellow: '노랑',
            neo_color_green: '초록',
            neo_color_blue: '파랑',
            neo_button_1: '버튼1',
            neo_button_2: '버튼2',
            neo_button_3: '버튼3',
            neo_button_4: '버튼4',
            neo_button_on: 'ON',
            neo_button_off: 'OFF',
            neo_buzzer_octave_1: '1옥타브',
            neo_buzzer_octave_2: '2옥타브',
            neo_buzzer_octave_3: '3옥타브',
            neo_buzzer_octave_4: '4옥타브',
            neo_buzzer_octave_5: '5옥타브',
            neo_buzzer_octave_6: '6옥타브',
            neo_buzzer_do: '도',
            neo_buzzer_do_sharp: '도#',
            neo_buzzer_re: '레',
            neo_buzzer_re_sharp: '레#',
            neo_buzzer_mi: '미',
            neo_buzzer_fa: '파',
            neo_buzzer_fa_sharp: '파#',
            neo_buzzer_sol: '솔',
            neo_buzzer_sol_sharp: '솔#',
            neo_buzzer_la: '라',
            neo_buzzer_la_sharp: '라#',
            neo_buzzer_ti: '시',
            neo_buzzer_whole_note: '온음표',
            neo_buzzer_half_note: '2분 음표',
            neo_buzzer_quarter_note: '4분 음표',
            neo_buzzer_8th_note: '8분 음표',
            neo_lcd_image_1: '화남',
            neo_lcd_image_2: '어지러움',
            neo_lcd_image_3: '똑똑함',
            neo_lcd_image_4: '활기참',
            neo_lcd_image_5: '뽀뽀',
            neo_lcd_image_6: '사랑해',
            neo_lcd_image_7: '윙크',
            neo_lcd_image_8: '폭풍눈물',
            neo_lcd_image_9: '졸림',
            neo_lcd_image_10: '미소',
            neo_lcd_image_11: '깜찍함',
            neo_lcd_image_12: '의심',
            neo_lcd_image_13: '못마땅'
          }
        },
        en: {
          // en.js에 작성하던 내용
          template: {
            // robot
            neo_robot_title: 'Robot',
            neo_robot_move: 'Move robot %1 %2 %3 %4',
            neo_robot_stop: 'Stop robot %1',
            // auto driving
            neo_auto_driving_title: 'Self-driving',
            neo_auto_driving_start: 'Start self-driving %1 %2 %3',
            neo_auto_driving_sensor_start: 'Start self-driving with %1 %2 %3',
            neo_auto_driving_stop: 'Stop self-driving %1',
            // auto parking
            neo_auto_parking_title: 'Auto parking | AiBle-only',
            neo_auto_parking_start: 'Start auto parking %1 %2 %3',
            // line tracer
            neo_line_tracer_title: 'Line tracer | AION-only',
            neo_line_tracer_start: 'Start line tracer with black line %1 %2 %3',
            neo_line_cross_move: 'Keep moving to the %1 intersection %2',
            neo_line_cross_turn: 'Turn %1 %2',
            neo_line_cross_reached: 'Reached an intersection?',
            // motor
            neo_motor_title: 'Motor',
            neo_motor_move: 'Move motor %1 %2 %3 %4',
            neo_motor_move_both: 'Move both motor L %1 R %2 %3',
            neo_motor_stop: 'Stop motor %1 %2',
            // servo
            neo_servo_title: 'Servo motor',
            neo_servo_reset: 'Reset the current position of %1 servo motor to 0 degree %2',
            neo_servo_angle: 'Change servo angle %1 %2 %3 %4',
            neo_servo_angle_var: 'Change servo angle %1 %2 %3 %4',
            neo_servo_angle_wait: 'Wait to change servo angle %1 %2 %3 %4',
            neo_servo_rotate: 'Rotate servo motor %1 %2 %3 %4',
            neo_servo_stop: 'Stop servo motor %1 %2',
            // led
            neo_led_title: 'LED',
            neo_led_on: 'Turn on the LED %1 %2 %3 %4',
            neo_led_blink: 'Blink the LED %1 %2 %3 %4',
            neo_led_off: 'Turn off the LED %1 %2',
            // set output
            neo_set_output_title: 'Set output',
            neo_set_output: 'Set output %1 %2 %3 %4',
            // color led
            neo_color_led_title: 'Color LED',
            neo_color_led_on: 'Turn on the color LED %1 %2 %3 %4',
            neo_color_led_off: 'Turn off the color LED %1 %2',
            neo_color_led_on_with_sensor: 'Turn on the color LED %2 with color sensor %1 %3',
            // sensor
            neo_sensor_title: 'Sensor',
            neo_sensor_in: '%1',
            neo_sensor_in_2: '%1',
            neo_sensor_digital_in: '%1 %2',
            neo_sensor_convert: '%1 : %2 %3 → %4 %5',
            neo_sensor_compare: '%1 %2 %3',
            neo_sensor_between: '%1 %2 %3 %4 %5',
            neo_sensor_digital_compare: '%1 %2 %3 %4',
            neo_sensor_color_compare: '%1 = %2',
            neo_sensor_color_sequence_compare: '%1 = %2 %3 %4',
            neo_sensor_button_pressed: '%1 %2',
            // buzzer
            neo_buzzer_title: 'Buzzer',
            neo_buzzer_start: 'Buzzer %1 %2 %3 %4',
            neo_buzzer_with_sensor: 'Buzzer by sensor value %1 %2',
            neo_buzzer_stop: 'Stop the buzzer %1',
            // lcd
            neo_lcd_title: 'LCD',
            neo_lcd_image: 'Show image on LCD %1 %2 %3',
            neo_lcd_text: 'Show text on LCD %1 %2 %3',
            // args
            neo_arg_duration: '%1',
            neo_arg_both_motor_speed: '%1',
            neo_arg_servo_angle: '%1'
          },
          Blocks: {
            neo_input_1: 'IN1',
            neo_input_2: 'IN2',
            neo_input_3: 'IN3',
            neo_input_12: 'IN1&2',
            neo_input_123: 'IN1&2&3',
            neo_input_1_2: 'IN1&IN2',
            neo_input_11_12: 'IN1-1&IN1-2',
            neo_input_13_14: 'IN1-3&IN1-4',
            neo_input_21_22: 'IN2-1&IN2-2',
            neo_input_23_24: 'IN2-3&IN2-4',
            neo_input_31_32: 'IN3-1&IN3-2',
            neo_input_33_34: 'IN3-3&IN3-4',
            neo_output_1: 'OUT1',
            neo_output_2: 'OUT2',
            neo_output_3: 'OUT3',
            neo_output_12: 'OUT1&2',
            neo_output_123: 'OUT1&2&3',
            neo_speed_0: '0%',
            neo_speed_5: '5%',
            neo_speed_10: '10%',
            neo_speed_15: '15%',
            neo_speed_20: '20%',
            neo_speed_25: '25%',
            neo_speed_30: '30%',
            neo_speed_35: '35%',
            neo_speed_40: '40%',
            neo_speed_45: '45%',
            neo_speed_50: '50%',
            neo_speed_55: '55%',
            neo_speed_60: '60%',
            neo_speed_65: '65%',
            neo_speed_70: '70%',
            neo_speed_75: '75%',
            neo_speed_80: '80%',
            neo_speed_85: '85%',
            neo_speed_90: '90%',
            neo_speed_95: '95%',
            neo_speed_100: '100%',
            neo_duration_c: 'constantly',
            neo_duration_0: '0 second',
            neo_duration_1: '1 second',
            neo_duration_2: '2 seconds',
            neo_duration_3: '3 seconds',
            neo_duration_4: '4 seconds',
            neo_duration_5: '5 seconds',
            neo_duration_6: '6 seconds',
            neo_duration_7: '7 seconds',
            neo_duration_8: '8 seconds',
            neo_duration_9: '9 seconds',
            neo_compare_gt: '≥',
            neo_compare_g: '>',
            neo_compare_e: '=',
            neo_compare_l: '<',
            neo_compare_lt: '≤',
            neo_turn_direction_l: 'left',
            neo_turn_direction_r: 'right',
            neo_turn_direction_u: 'U-turn',
            neo_motor_out_l: 'left',
            neo_motor_out_r: 'right',
            neo_motor_out_lr: 'both',
            neo_motor_speed_n100: '-100%',
            neo_motor_speed_n95: '-95%',
            neo_motor_speed_n90: '-90%',
            neo_motor_speed_n85: '-85%',
            neo_motor_speed_n80: '-80%',
            neo_motor_speed_n75: '-75%',
            neo_motor_speed_n70: '-70%',
            neo_motor_speed_n65: '-65%',
            neo_motor_speed_n60: '-60%',
            neo_motor_speed_n55: '-55%',
            neo_motor_speed_n50: '-50%',
            neo_motor_speed_n45: '-45%',
            neo_motor_speed_n40: '-40%',
            neo_motor_speed_n35: '-35%',
            neo_motor_speed_n30: '-30%',
            neo_motor_speed_n25: '-25%',
            neo_motor_speed_n20: '-20%',
            neo_motor_speed_n15: '-15%',
            neo_motor_speed_n10: '-10%',
            neo_motor_speed_n5: '-5%',
            neo_motor_speed_0: '0%',
            neo_motor_speed_5: '5%',
            neo_motor_speed_10: '10%',
            neo_motor_speed_15: '15%',
            neo_motor_speed_20: '20%',
            neo_motor_speed_25: '25%',
            neo_motor_speed_30: '30%',
            neo_motor_speed_35: '35%',
            neo_motor_speed_40: '40%',
            neo_motor_speed_45: '45%',
            neo_motor_speed_50: '50%',
            neo_motor_speed_55: '55%',
            neo_motor_speed_60: '60%',
            neo_motor_speed_65: '65%',
            neo_motor_speed_70: '70%',
            neo_motor_speed_75: '75%',
            neo_motor_speed_80: '80%',
            neo_motor_speed_85: '85%',
            neo_motor_speed_90: '90%',
            neo_motor_speed_95: '95%',
            neo_motor_speed_100: '100%',
            neo_robot_direction_f: 'forward',
            neo_robot_direction_b: 'backward',
            neo_robot_direction_l: 'left',
            neo_robot_direction_r: 'right',
            neo_robot_direction_tl: 'left in place',
            neo_robot_direction_tr: 'right in place',
            neo_servo_angle_n360: '-360 degree',
            neo_servo_angle_n350: '-350 degree',
            neo_servo_angle_n340: '-340 degree',
            neo_servo_angle_n330: '-330 degree',
            neo_servo_angle_n320: '-320 degree',
            neo_servo_angle_n310: '-310 degree',
            neo_servo_angle_n300: '-300 degree',
            neo_servo_angle_n290: '-290 degree',
            neo_servo_angle_n280: '-280 degree',
            neo_servo_angle_n270: '-270 degree',
            neo_servo_angle_n260: '-260 degree',
            neo_servo_angle_n250: '-250 degree',
            neo_servo_angle_n240: '-240 degree',
            neo_servo_angle_n230: '-230 degree',
            neo_servo_angle_n220: '-220 degree',
            neo_servo_angle_n210: '-210 degree',
            neo_servo_angle_n200: '-200 degree',
            neo_servo_angle_n190: '-190 degree',
            neo_servo_angle_n180: '-180 degree',
            neo_servo_angle_n170: '-170 degree',
            neo_servo_angle_n160: '-160 degree',
            neo_servo_angle_n150: '-150 degree',
            neo_servo_angle_n140: '-140 degree',
            neo_servo_angle_n130: '-130 degree',
            neo_servo_angle_n120: '-120 degree',
            neo_servo_angle_n110: '-110 degree',
            neo_servo_angle_n100: '-100 degree',
            neo_servo_angle_n90: '-90 degree',
            neo_servo_angle_n80: '-80 degree',
            neo_servo_angle_n70: '-70 degree',
            neo_servo_angle_n60: '-60 degree',
            neo_servo_angle_n50: '-50 degree',
            neo_servo_angle_n40: '-40 degree',
            neo_servo_angle_n30: '-30 degree',
            neo_servo_angle_n20: '-20 degree',
            neo_servo_angle_n10: '-10 degree',
            neo_servo_angle_0: '0 degree',
            neo_servo_angle_10: '10 degree',
            neo_servo_angle_20: '20 degree',
            neo_servo_angle_30: '30 degree',
            neo_servo_angle_40: '40 degree',
            neo_servo_angle_50: '50 degree',
            neo_servo_angle_60: '60 degree',
            neo_servo_angle_70: '70 degree',
            neo_servo_angle_80: '80 degree',
            neo_servo_angle_90: '90 degree',
            neo_servo_angle_100: '100 degree',
            neo_servo_angle_110: '110 degree',
            neo_servo_angle_120: '120 degree',
            neo_servo_angle_130: '130 degree',
            neo_servo_angle_140: '140 degree',
            neo_servo_angle_150: '150 degree',
            neo_servo_angle_160: '160 degree',
            neo_servo_angle_170: '170 degree',
            neo_servo_angle_180: '180 degree',
            neo_servo_angle_190: '190 degree',
            neo_servo_angle_200: '200 degree',
            neo_servo_angle_210: '210 degree',
            neo_servo_angle_220: '220 degree',
            neo_servo_angle_230: '230 degree',
            neo_servo_angle_240: '240 degree',
            neo_servo_angle_250: '250 degree',
            neo_servo_angle_260: '260 degree',
            neo_servo_angle_270: '270 degree',
            neo_servo_angle_280: '280 degree',
            neo_servo_angle_290: '290 degree',
            neo_servo_angle_300: '300 degree',
            neo_servo_angle_310: '310 degree',
            neo_servo_angle_320: '320 degree',
            neo_servo_angle_330: '330 degree',
            neo_servo_angle_340: '340 degree',
            neo_servo_angle_350: '350 degree',
            neo_servo_angle_360: '360 degree',
            neo_servo_direction_f: 'forward',
            neo_servo_direction_b: 'backward',
            neo_line_cross_move_1: '1st',
            neo_line_cross_move_2: '2nd',
            neo_line_cross_move_3: '3rd',
            neo_line_cross_move_4: '4th',
            neo_line_cross_move_5: '5th',
            neo_line_cross_move_6: '6th',
            neo_line_cross_move_7: '7th',
            neo_line_cross_move_8: '8th',
            neo_line_cross_move_9: '9th',
            neo_line_cross_move_10: '10th',
            neo_line_cross_turn_direction_l: 'to left',
            neo_line_cross_turn_direction_r: 'to right',
            neo_line_cross_turn_direction_u: 'U-turn',
            neo_line_cross_turn_which_next: 'next',
            neo_line_cross_turn_which_current: 'current',
            neo_auto_driving_speed_in3: 'IN3',
            neo_auto_parking_which_l: 'to left',
            neo_auto_parking_which_r: 'to right',
            neo_auto_parking_direction_b: 'rear parking',
            neo_auto_parking_direction_s: 'parallel parking',
            neo_led_brightness_0: '0%',
            neo_led_brightness_5: '5%',
            neo_led_brightness_10: '10%',
            neo_led_brightness_15: '15%',
            neo_led_brightness_20: '20%',
            neo_led_brightness_25: '25%',
            neo_led_brightness_30: '30%',
            neo_led_brightness_35: '35%',
            neo_led_brightness_40: '40%',
            neo_led_brightness_45: '45%',
            neo_led_brightness_50: '50%',
            neo_led_brightness_55: '55%',
            neo_led_brightness_60: '60%',
            neo_led_brightness_65: '65%',
            neo_led_brightness_70: '70%',
            neo_led_brightness_75: '75%',
            neo_led_brightness_80: '80%',
            neo_led_brightness_85: '85%',
            neo_led_brightness_90: '90%',
            neo_led_brightness_95: '95%',
            neo_led_brightness_100: '100%',
            neo_led_blink_speed_1: 'stage 1',
            neo_led_blink_speed_2: 'stage 2',
            neo_led_blink_speed_3: 'stage 3',
            neo_led_blink_speed_4: 'stage 4',
            neo_led_blink_speed_5: 'stage 5',
            neo_set_output_value_0: '0',
            neo_set_output_value_5: '5',
            neo_set_output_value_10: '10',
            neo_set_output_value_15: '15',
            neo_set_output_value_20: '20',
            neo_set_output_value_25: '25',
            neo_set_output_value_30: '30',
            neo_set_output_value_35: '35',
            neo_set_output_value_40: '40',
            neo_set_output_value_45: '45',
            neo_set_output_value_50: '50',
            neo_set_output_value_55: '55',
            neo_set_output_value_60: '60',
            neo_set_output_value_65: '65',
            neo_set_output_value_70: '70',
            neo_set_output_value_75: '75',
            neo_set_output_value_80: '80',
            neo_set_output_value_85: '85',
            neo_set_output_value_90: '90',
            neo_set_output_value_95: '95',
            neo_set_output_value_100: '100',
            neo_set_output_value_105: '105',
            neo_set_output_value_110: '110',
            neo_set_output_value_115: '115',
            neo_set_output_value_120: '120',
            neo_set_output_value_125: '125',
            neo_set_output_value_130: '130',
            neo_set_output_value_135: '135',
            neo_set_output_value_140: '140',
            neo_set_output_value_145: '145',
            neo_set_output_value_150: '150',
            neo_set_output_value_155: '155',
            neo_set_output_value_160: '160',
            neo_set_output_value_165: '165',
            neo_set_output_value_170: '170',
            neo_set_output_value_175: '175',
            neo_set_output_value_180: '180',
            neo_set_output_value_185: '185',
            neo_set_output_value_190: '190',
            neo_set_output_value_195: '195',
            neo_set_output_value_200: '200',
            neo_set_output_value_205: '205',
            neo_set_output_value_210: '210',
            neo_set_output_value_215: '215',
            neo_set_output_value_220: '220',
            neo_set_output_value_225: '225',
            neo_set_output_value_230: '230',
            neo_set_output_value_235: '235',
            neo_set_output_value_240: '240',
            neo_set_output_value_245: '245',
            neo_set_output_value_250: '250',
            neo_set_output_value_255: '255',
            neo_sensor_in_digital_1: '1st',
            neo_sensor_in_digital_2: '2nd',
            neo_sensor_in_digital_3: '3rd',
            neo_sensor_in_digital_4: '4th',
            neo_color_black: 'black',
            neo_color_white: 'white',
            neo_color_red: 'red',
            neo_color_yellow: 'yellow',
            neo_color_green: 'green',
            neo_color_blue: 'blue',
            neo_button_1: 'button 1',
            neo_button_2: 'button 2',
            neo_button_3: 'button 3',
            neo_button_4: 'button 4',
            neo_button_on: 'ON',
            neo_button_off: 'OFF',
            neo_buzzer_octave_1: '1 octave',
            neo_buzzer_octave_2: '2 octave',
            neo_buzzer_octave_3: '3 octave',
            neo_buzzer_octave_4: '4 octave',
            neo_buzzer_octave_5: '5 octave',
            neo_buzzer_octave_6: '6 octave',
            neo_buzzer_do: 'Do',
            neo_buzzer_do_sharp: 'Do#',
            neo_buzzer_re: 'Re',
            neo_buzzer_re_sharp: 'Re#',
            neo_buzzer_mi: 'Mi',
            neo_buzzer_fa: 'Fa',
            neo_buzzer_fa_sharp: 'Fa#',
            neo_buzzer_sol: 'So',
            neo_buzzer_sol_sharp: 'So#',
            neo_buzzer_la: 'La',
            neo_buzzer_la_sharp: 'La#',
            neo_buzzer_ti: 'Si',
            neo_buzzer_whole_note: 'whole note',
            neo_buzzer_half_note: 'a half note',
            neo_buzzer_quarter_note: 'a quarter note',
            neo_buzzer_8th_note: 'a eighth note',
            neo_lcd_image_1: 'angry',
            neo_lcd_image_2: 'dizzy',
            neo_lcd_image_3: 'smart',
            neo_lcd_image_4: 'lively',
            neo_lcd_image_5: 'kiss',
            neo_lcd_image_6: 'lovely',
            neo_lcd_image_7: 'wink',
            neo_lcd_image_8: 'cry',
            neo_lcd_image_9: 'sleepy',
            neo_lcd_image_10: 'smiley',
            neo_lcd_image_11: 'cute',
            neo_lcd_image_12: 'doubt',
            neo_lcd_image_13: 'bad'
          }
        } //
      };
    }
  }, {
    key: "getBlocks",
    value: function getBlocks() {
      var _this = this;
      return {
        /**
         * 로봇
         */
        neo_robot_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_robot_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_robot_title'
          },
          "class": 'neo_robot',
          isNotFor: ['neo'],
          events: {}
        },
        neo_robot_move: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_robot_direction_f, 1], [Lang.Blocks.neo_robot_direction_b, 2], [Lang.Blocks.neo_robot_direction_l, 3], [Lang.Blocks.neo_robot_direction_r, 4], [Lang.Blocks.neo_robot_direction_tl, 5], [Lang.Blocks.neo_robot_direction_tr, 6]],
            value: 1,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_95, '95'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_85, '85'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_75, '75'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_65, '65'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_55, '55'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_45, '45'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_35, '35'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_25, '25'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_15, '15'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_5, '5'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '100',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, {
              type: 'neo_arg_duration'
            }, null],
            type: 'neo_robot_move'
          },
          paramsKeyMap: {
            DIRECTION: 0,
            SPEED: 1,
            DURATION: 2
          },
          "class": 'neo_robot',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var direction = script.getNumberField('DIRECTION');
              var speed = script.getStringField('SPEED');
              var duration = script.getStringValue('DURATION', script);
              var blockId = _this.generateBlockId();
              if (speed.indexOf('IN') >= 0) {
                _this.requestExtCommand(blockId, NeoBlockType.ROBOT_MOVE, [direction, speed]);
              } else {
                _this.requestCommand(blockId, NeoBlockType.ROBOT_MOVE, [direction, speed]);
              }
              if (duration === 'c' || !Entry.parseNumber(duration)) {
                script.block_id = blockId;
                script.exec_phase = ExecPhase.PENDING_STOP;
              } else {
                script.exec_phase = ExecPhase.SET_TIMEOUT;
              }
            } else if (script.exec_phase === ExecPhase.SET_TIMEOUT) {
              var _duration = script.getStringValue('DURATION', script);
              var durationValue = Entry.parseNumber(_duration);
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, durationValue * 1000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _direction = script.getNumberField('DIRECTION', script);
              var _blockId = _this.generateBlockId();
              script.block_id = _blockId;
              _this.requestCommand(_blockId, NeoBlockType.ROBOT_MOVE, [_direction, 0]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_robot_stop: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null],
            type: 'neo_robot_stop'
          },
          paramsKeyMap: {
            //
          },
          "class": 'neo_robot',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              _this.requestCommand(blockId, NeoBlockType.ROBOT_STOP, []);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * 자율주행
         */
        neo_auto_driving_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_auto_driving_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_auto_driving_title'
          },
          "class": 'neo_auto_driving',
          isNotFor: ['neo'],
          events: {}
        },
        neo_auto_driving_start: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_95, '95'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_85, '85'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_75, '75'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_65, '65'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_55, '55'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_45, '45'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_35, '35'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_25, '25'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_15, '15'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_5, '5'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '60',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, {
              type: 'neo_arg_duration'
            }, null],
            type: 'neo_auto_driving_start'
          },
          paramsKeyMap: {
            SPEED: 0,
            DURATION: 1
          },
          "class": 'neo_auto_driving',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var speed = script.getStringField('SPEED');
              var duration = script.getStringValue('DURATION', script);
              var blockId = _this.generateBlockId();
              if (speed.indexOf('IN') >= 0) {
                _this.requestExtCommand(blockId, NeoBlockType.AUTO_DRIVING_START, [speed]);
              } else {
                _this.requestCommand(blockId, NeoBlockType.AUTO_DRIVING_START, [speed]);
              }
              if (duration === 'c' || !Entry.parseNumber(duration)) {
                script.block_id = blockId;
                script.exec_phase = ExecPhase.PENDING_STOP;
              } else {
                script.exec_phase = ExecPhase.SET_TIMEOUT;
              }
            } else if (script.exec_phase === ExecPhase.SET_TIMEOUT) {
              var _duration2 = script.getStringValue('DURATION', script);
              var durationValue = Entry.parseNumber(_duration2);
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, durationValue * 1000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _blockId2 = _this.generateBlockId();
              script.block_id = _blockId2;
              _this.requestCommand(_blockId2, NeoBlockType.AUTO_DRIVING_START, [0]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_auto_driving_sensor_start: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_input_1_2, 0x10], [Lang.Blocks.neo_input_11_12, 0x11], [Lang.Blocks.neo_input_13_14, 0x12], [Lang.Blocks.neo_input_21_22, 0x13], [Lang.Blocks.neo_input_23_24, 0x14], [Lang.Blocks.neo_input_31_32, 0x15], [Lang.Blocks.neo_input_33_34, 0x16]],
            value: 0x10,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_95, '95'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_85, '85'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_75, '75'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_65, '65'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_55, '55'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_45, '45'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_35, '35'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_25, '25'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_15, '15'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_5, '5'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '60',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, null],
            type: 'neo_auto_driving_sensor_start'
          },
          paramsKeyMap: {
            SENSOR: 0,
            SPEED: 1
          },
          "class": 'neo_auto_driving',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var sensor = script.getNumberField('SENSOR');
              var speed = script.getStringField('SPEED');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              if (speed.indexOf('IN') >= 0) {
                _this.requestExtCommand(blockId, NeoBlockType.AUTO_DRIVING_SENSOR_START, [sensor, speed]);
              } else {
                _this.requestCommand(blockId, NeoBlockType.AUTO_DRIVING_SENSOR_START, [sensor, speed]);
              }
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_auto_driving_stop: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null],
            type: 'neo_auto_driving_stop'
          },
          paramsKeyMap: {
            DIRECTION: 0
          },
          "class": 'neo_auto_driving',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.AUTO_DRIVING_STOP, []);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * 자율주차
         */
        neo_auto_parking_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_auto_parking_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_auto_parking_title'
          },
          "class": 'neo_auto_parking',
          isNotFor: ['neo'],
          events: {}
        },
        neo_auto_parking_start: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_auto_parking_which_l, 1], [Lang.Blocks.neo_auto_parking_which_r, 2]],
            value: 1,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_auto_parking_direction_b, 1], [Lang.Blocks.neo_auto_parking_direction_s, 2]],
            value: 1,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, null],
            type: 'neo_auto_parking_start'
          },
          paramsKeyMap: {
            WHICH: 0,
            DIRECTION: 1
          },
          "class": 'neo_auto_parking',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            return _this.runAutoParking(script);
          }
        },
        /**
         * 라인트레이서
         */
        neo_line_tracer_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_line_tracer_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_line_tracer_title'
          },
          "class": 'neo_line_tracer',
          isNotFor: ['neo'],
          events: {}
        },
        neo_line_tracer_start: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_95, '95'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_85, '85'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_75, '75'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_65, '65'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_55, '55'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_45, '45'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_35, '35'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_25, '25'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_15, '15'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_5, '5'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '60',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, {
              type: 'neo_arg_duration'
            }, null],
            type: 'neo_line_tracer_start'
          },
          paramsKeyMap: {
            SPEED: 0,
            DURATION: 1
          },
          "class": 'neo_auto_driving',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var speed = script.getStringField('SPEED');
              var blockId = _this.generateBlockId();
              var duration = script.getStringValue('DURATION', script);
              if (speed.indexOf('IN') >= 0) {
                _this.requestExtCommand(blockId, NeoBlockType.LINE_TRACER_START, [speed]);
              } else {
                _this.requestCommand(blockId, NeoBlockType.LINE_TRACER_START, [speed]);
              }
              if (duration === 'c' || !Entry.parseNumber(duration)) {
                script.block_id = blockId;
                script.exec_phase = ExecPhase.PENDING_STOP;
              } else {
                script.exec_phase = ExecPhase.SET_TIMEOUT;
              }
            } else if (script.exec_phase === ExecPhase.SET_TIMEOUT) {
              var _duration3 = script.getStringValue('DURATION', script);
              var durationValue = Entry.parseNumber(_duration3);
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, durationValue * 1000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _blockId3 = _this.generateBlockId();
              script.block_id = _blockId3;
              _this.requestCommand(_blockId3, NeoBlockType.LINE_TRACER_START, [0]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_line_cross_move: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_line_cross_move_1, 1], [Lang.Blocks.neo_line_cross_move_2, 2], [Lang.Blocks.neo_line_cross_move_3, 3], [Lang.Blocks.neo_line_cross_move_4, 4], [Lang.Blocks.neo_line_cross_move_5, 5], [Lang.Blocks.neo_line_cross_move_6, 6], [Lang.Blocks.neo_line_cross_move_7, 7], [Lang.Blocks.neo_line_cross_move_8, 8], [Lang.Blocks.neo_line_cross_move_9, 9], [Lang.Blocks.neo_line_cross_move_10, 10]],
            value: 1,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_line_cross_move'
          },
          paramsKeyMap: {
            COUNT: 0
          },
          "class": 'neo_auto_driving',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var count = script.getStringField('COUNT');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.LINE_CROSS_MOVE, [count]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_line_cross_turn: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_turn_direction_l, 30], [Lang.Blocks.neo_turn_direction_r, 31]],
            value: 30,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_line_cross_turn'
          },
          paramsKeyMap: {
            DIRECTION: 0
          },
          "class": 'neo_auto_driving',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var direction = script.getStringField('DIRECTION');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.LINE_CROSS_TURN, [direction]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_line_cross_reached: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic_boolean_field',
          fontColor: '#fff',
          statements: [],
          params: [],
          events: {},
          def: {
            params: [],
            type: 'neo_line_cross_reached'
          },
          paramsKeyMap: {},
          "class": 'neo_auto_driving',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var sensorData = Entry.hw.portData['sensor'];
            var leftValue = sensorData['in1Values'][0];
            var rightValue = sensorData['in1Values'][1];
            return 0 <= leftValue && leftValue <= 50 && 0 <= rightValue && rightValue <= 50;
          }
        },
        /**
         * 회전모터
         */
        neo_motor_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_motor_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_motor_title'
          },
          "class": 'neo_motor',
          isNotFor: ['neo'],
          events: {}
        },
        neo_motor_move: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_out_l, 1], [Lang.Blocks.neo_motor_out_r, 2], [Lang.Blocks.neo_motor_out_lr, 0]],
            value: 1,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_95, '95'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_85, '85'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_75, '75'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_65, '65'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_55, '55'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_45, '45'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_35, '35'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_25, '25'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_15, '15'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_5, '5'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_motor_speed_n5, '-5'], [Lang.Blocks.neo_motor_speed_n10, '-10'], [Lang.Blocks.neo_motor_speed_n15, '-15'], [Lang.Blocks.neo_motor_speed_n20, '-20'], [Lang.Blocks.neo_motor_speed_n25, '-25'], [Lang.Blocks.neo_motor_speed_n30, '-30'], [Lang.Blocks.neo_motor_speed_n35, '-35'], [Lang.Blocks.neo_motor_speed_n40, '-40'], [Lang.Blocks.neo_motor_speed_n45, '-45'], [Lang.Blocks.neo_motor_speed_n50, '-50'], [Lang.Blocks.neo_motor_speed_n55, '-55'], [Lang.Blocks.neo_motor_speed_n60, '-60'], [Lang.Blocks.neo_motor_speed_n65, '-65'], [Lang.Blocks.neo_motor_speed_n70, '-70'], [Lang.Blocks.neo_motor_speed_n75, '-75'], [Lang.Blocks.neo_motor_speed_n80, '-80'], [Lang.Blocks.neo_motor_speed_n85, '-85'], [Lang.Blocks.neo_motor_speed_n90, '-90'], [Lang.Blocks.neo_motor_speed_n95, '-95'], [Lang.Blocks.neo_motor_speed_n100, '-100'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '100',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, {
              type: 'neo_arg_duration'
            }, null],
            type: 'neo_motor_move'
          },
          paramsKeyMap: {
            DC: 0,
            SPEED: 1,
            DURATION: 2
          },
          "class": 'neo_motor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var dc = script.getNumberField('DC');
              var speed = script.getStringField('SPEED');
              var duration = script.getStringValue('DURATION', script);
              var blockId = _this.generateBlockId();
              if (speed.indexOf('IN') >= 0) {
                _this.requestExtCommand(blockId, NeoBlockType.MOTOR_MOVE, [dc, speed]);
              } else {
                _this.requestCommand(blockId, NeoBlockType.MOTOR_MOVE, [dc, speed]);
              }
              if (duration === 'c' || !Entry.parseNumber(duration)) {
                script.block_id = blockId;
                script.exec_phase = ExecPhase.PENDING_STOP;
              } else {
                script.exec_phase = ExecPhase.SET_TIMEOUT;
              }
            } else if (script.exec_phase === ExecPhase.SET_TIMEOUT) {
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              var _duration4 = script.getStringValue('DURATION', script);
              var durationValue = Entry.parseNumber(_duration4);
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, durationValue * 1000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _dc = script.getNumberField('DC', script);
              var _blockId4 = _this.generateBlockId();
              script.block_id = _blockId4;
              _this.requestCommand(_blockId4, NeoBlockType.MOTOR_MOVE, [_dc, 0]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_motor_move_both: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [{
              type: 'neo_arg_both_motor_speed'
            }, {
              type: 'neo_arg_both_motor_speed'
            }, null],
            type: 'neo_motor_move_both'
          },
          paramsKeyMap: {
            SPEED_L: 0,
            SPEED_R: 1
          },
          "class": 'neo_motor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var speedL = script.getNumberValue('SPEED_L', script);
              var speedR = script.getNumberValue('SPEED_R', script);
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.MOTOR_MOVE_BOTH, [speedL, speedR]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_motor_stop: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_out_l, 1], [Lang.Blocks.neo_motor_out_r, 2], [Lang.Blocks.neo_motor_out_lr, 0]],
            value: 1,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_motor_stop'
          },
          paramsKeyMap: {
            DC: 0
          },
          "class": 'neo_motor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var dc = script.getStringField('DC');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              _this.requestCommand(blockId, NeoBlockType.MOTOR_STOP, [dc]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * 서보모터
         */
        neo_servo_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_servo_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_servo_title'
          },
          "class": 'neo_servo',
          isNotFor: ['neo'],
          events: {}
        },
        neo_servo_reset: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_servo_reset'
          },
          paramsKeyMap: {
            OUTPUT: 0
          },
          "class": 'neo_servo',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.SERVO_RESET, [output]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_servo_angle: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_servo_angle_360, '360'], [Lang.Blocks.neo_servo_angle_350, '350'], [Lang.Blocks.neo_servo_angle_340, '340'], [Lang.Blocks.neo_servo_angle_330, '330'], [Lang.Blocks.neo_servo_angle_320, '320'], [Lang.Blocks.neo_servo_angle_310, '310'], [Lang.Blocks.neo_servo_angle_300, '300'], [Lang.Blocks.neo_servo_angle_290, '290'], [Lang.Blocks.neo_servo_angle_280, '280'], [Lang.Blocks.neo_servo_angle_270, '270'], [Lang.Blocks.neo_servo_angle_260, '260'], [Lang.Blocks.neo_servo_angle_250, '250'], [Lang.Blocks.neo_servo_angle_240, '240'], [Lang.Blocks.neo_servo_angle_230, '230'], [Lang.Blocks.neo_servo_angle_220, '220'], [Lang.Blocks.neo_servo_angle_210, '210'], [Lang.Blocks.neo_servo_angle_200, '200'], [Lang.Blocks.neo_servo_angle_190, '190'], [Lang.Blocks.neo_servo_angle_180, '180'], [Lang.Blocks.neo_servo_angle_170, '170'], [Lang.Blocks.neo_servo_angle_160, '160'], [Lang.Blocks.neo_servo_angle_150, '150'], [Lang.Blocks.neo_servo_angle_140, '140'], [Lang.Blocks.neo_servo_angle_130, '130'], [Lang.Blocks.neo_servo_angle_120, '120'], [Lang.Blocks.neo_servo_angle_110, '110'], [Lang.Blocks.neo_servo_angle_100, '100'], [Lang.Blocks.neo_servo_angle_90, '90'], [Lang.Blocks.neo_servo_angle_80, '80'], [Lang.Blocks.neo_servo_angle_70, '70'], [Lang.Blocks.neo_servo_angle_60, '60'], [Lang.Blocks.neo_servo_angle_50, '50'], [Lang.Blocks.neo_servo_angle_40, '40'], [Lang.Blocks.neo_servo_angle_30, '30'], [Lang.Blocks.neo_servo_angle_20, '20'], [Lang.Blocks.neo_servo_angle_10, '10'], [Lang.Blocks.neo_servo_angle_0, '0'], [Lang.Blocks.neo_servo_angle_n10, '-10'], [Lang.Blocks.neo_servo_angle_n20, '-20'], [Lang.Blocks.neo_servo_angle_n30, '-30'], [Lang.Blocks.neo_servo_angle_n40, '-40'], [Lang.Blocks.neo_servo_angle_n50, '-50'], [Lang.Blocks.neo_servo_angle_n60, '-60'], [Lang.Blocks.neo_servo_angle_n70, '-70'], [Lang.Blocks.neo_servo_angle_n80, '-80'], [Lang.Blocks.neo_servo_angle_n90, '-90'], [Lang.Blocks.neo_servo_angle_n100, '-100'], [Lang.Blocks.neo_servo_angle_n110, '-110'], [Lang.Blocks.neo_servo_angle_n120, '-120'], [Lang.Blocks.neo_servo_angle_n130, '-130'], [Lang.Blocks.neo_servo_angle_n140, '-140'], [Lang.Blocks.neo_servo_angle_n150, '-150'], [Lang.Blocks.neo_servo_angle_n160, '-160'], [Lang.Blocks.neo_servo_angle_n170, '-170'], [Lang.Blocks.neo_servo_angle_n180, '-180'], [Lang.Blocks.neo_servo_angle_n190, '-190'], [Lang.Blocks.neo_servo_angle_n200, '-200'], [Lang.Blocks.neo_servo_angle_n210, '-210'], [Lang.Blocks.neo_servo_angle_n220, '-220'], [Lang.Blocks.neo_servo_angle_n230, '-230'], [Lang.Blocks.neo_servo_angle_n240, '-240'], [Lang.Blocks.neo_servo_angle_n250, '-250'], [Lang.Blocks.neo_servo_angle_n260, '-260'], [Lang.Blocks.neo_servo_angle_n270, '-270'], [Lang.Blocks.neo_servo_angle_n280, '-280'], [Lang.Blocks.neo_servo_angle_n290, '-290'], [Lang.Blocks.neo_servo_angle_n300, '-300'], [Lang.Blocks.neo_servo_angle_n310, '-310'], [Lang.Blocks.neo_servo_angle_n320, '-320'], [Lang.Blocks.neo_servo_angle_n330, '-330'], [Lang.Blocks.neo_servo_angle_n340, '-340'], [Lang.Blocks.neo_servo_angle_n350, '-350'], [Lang.Blocks.neo_servo_angle_n360, '-360'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '90',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '50',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, null, null],
            type: 'neo_servo_angle'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            ANGLE: 1,
            SPEED: 2
          },
          "class": 'neo_servo',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var angle = script.getStringField('ANGLE');
              var speed = script.getStringField('SPEED');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              var isExt2 = angle.indexOf('IN') >= 0 && speed.indexOf('IN') >= 0;
              if (isExt2) {
                _this.requestExt2Command(blockId, NeoBlockType.SERVO_ANGLE, [output, angle, speed]);
              } else {
                var isExt1 = angle.indexOf('IN') >= 0 || speed.indexOf('IN') >= 0;
                if (isExt1) {
                  _this.requestExtCommand(blockId, NeoBlockType.SERVO_ANGLE, [output, angle, speed]);
                } else {
                  _this.requestCommand(blockId, NeoBlockType.SERVO_ANGLE, [output, angle, speed]);
                }
              }
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_servo_angle_var: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '50',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, {
              type: 'neo_arg_servo_angle'
            }, null, null],
            type: 'neo_servo_angle_var'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            ANGLE: 1,
            SPEED: 2
          },
          "class": 'neo_servo',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var angle = script.getNumberValue('ANGLE', script);
              var speed = script.getStringField('SPEED');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.SERVO_ANGLE, [output, angle, speed]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_servo_angle_wait: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_servo_angle_360, '360'], [Lang.Blocks.neo_servo_angle_350, '350'], [Lang.Blocks.neo_servo_angle_340, '340'], [Lang.Blocks.neo_servo_angle_330, '330'], [Lang.Blocks.neo_servo_angle_320, '320'], [Lang.Blocks.neo_servo_angle_310, '310'], [Lang.Blocks.neo_servo_angle_300, '300'], [Lang.Blocks.neo_servo_angle_290, '290'], [Lang.Blocks.neo_servo_angle_280, '280'], [Lang.Blocks.neo_servo_angle_270, '270'], [Lang.Blocks.neo_servo_angle_260, '260'], [Lang.Blocks.neo_servo_angle_250, '250'], [Lang.Blocks.neo_servo_angle_240, '240'], [Lang.Blocks.neo_servo_angle_230, '230'], [Lang.Blocks.neo_servo_angle_220, '220'], [Lang.Blocks.neo_servo_angle_210, '210'], [Lang.Blocks.neo_servo_angle_200, '200'], [Lang.Blocks.neo_servo_angle_190, '190'], [Lang.Blocks.neo_servo_angle_180, '180'], [Lang.Blocks.neo_servo_angle_170, '170'], [Lang.Blocks.neo_servo_angle_160, '160'], [Lang.Blocks.neo_servo_angle_150, '150'], [Lang.Blocks.neo_servo_angle_140, '140'], [Lang.Blocks.neo_servo_angle_130, '130'], [Lang.Blocks.neo_servo_angle_120, '120'], [Lang.Blocks.neo_servo_angle_110, '110'], [Lang.Blocks.neo_servo_angle_100, '100'], [Lang.Blocks.neo_servo_angle_90, '90'], [Lang.Blocks.neo_servo_angle_80, '80'], [Lang.Blocks.neo_servo_angle_70, '70'], [Lang.Blocks.neo_servo_angle_60, '60'], [Lang.Blocks.neo_servo_angle_50, '50'], [Lang.Blocks.neo_servo_angle_40, '40'], [Lang.Blocks.neo_servo_angle_30, '30'], [Lang.Blocks.neo_servo_angle_20, '20'], [Lang.Blocks.neo_servo_angle_10, '10'], [Lang.Blocks.neo_servo_angle_0, '0'], [Lang.Blocks.neo_servo_angle_n10, '-10'], [Lang.Blocks.neo_servo_angle_n20, '-20'], [Lang.Blocks.neo_servo_angle_n30, '-30'], [Lang.Blocks.neo_servo_angle_n40, '-40'], [Lang.Blocks.neo_servo_angle_n50, '-50'], [Lang.Blocks.neo_servo_angle_n60, '-60'], [Lang.Blocks.neo_servo_angle_n70, '-70'], [Lang.Blocks.neo_servo_angle_n80, '-80'], [Lang.Blocks.neo_servo_angle_n90, '-90'], [Lang.Blocks.neo_servo_angle_n100, '-100'], [Lang.Blocks.neo_servo_angle_n110, '-110'], [Lang.Blocks.neo_servo_angle_n120, '-120'], [Lang.Blocks.neo_servo_angle_n130, '-130'], [Lang.Blocks.neo_servo_angle_n140, '-140'], [Lang.Blocks.neo_servo_angle_n150, '-150'], [Lang.Blocks.neo_servo_angle_n160, '-160'], [Lang.Blocks.neo_servo_angle_n170, '-170'], [Lang.Blocks.neo_servo_angle_n180, '-180'], [Lang.Blocks.neo_servo_angle_n190, '-190'], [Lang.Blocks.neo_servo_angle_n200, '-200'], [Lang.Blocks.neo_servo_angle_n210, '-210'], [Lang.Blocks.neo_servo_angle_n220, '-220'], [Lang.Blocks.neo_servo_angle_n230, '-230'], [Lang.Blocks.neo_servo_angle_n240, '-240'], [Lang.Blocks.neo_servo_angle_n250, '-250'], [Lang.Blocks.neo_servo_angle_n260, '-260'], [Lang.Blocks.neo_servo_angle_n270, '-270'], [Lang.Blocks.neo_servo_angle_n280, '-280'], [Lang.Blocks.neo_servo_angle_n290, '-290'], [Lang.Blocks.neo_servo_angle_n300, '-300'], [Lang.Blocks.neo_servo_angle_n310, '-310'], [Lang.Blocks.neo_servo_angle_n320, '-320'], [Lang.Blocks.neo_servo_angle_n330, '-330'], [Lang.Blocks.neo_servo_angle_n340, '-340'], [Lang.Blocks.neo_servo_angle_n350, '-350'], [Lang.Blocks.neo_servo_angle_n360, '-360'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '90',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_0, '0']],
            value: '50',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, null, null],
            type: 'neo_servo_angle_wait'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            ANGLE: 1,
            SPEED: 2
          },
          "class": 'neo_servo',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var angle = script.getStringField('ANGLE');
              var speed = script.getStringField('SPEED');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              var isExt2 = angle.indexOf('IN') >= 0 && speed.indexOf('IN') >= 0;
              if (isExt2) {
                _this.requestExt2Command(blockId, NeoBlockType.SERVO_ANGLE_WAIT, [output, angle, speed]);
              } else {
                var isExt1 = angle.indexOf('IN') >= 0 || speed.indexOf('IN') >= 0;
                if (isExt1) {
                  _this.requestExtCommand(blockId, NeoBlockType.SERVO_ANGLE_WAIT, [output, angle, speed]);
                } else {
                  _this.requestCommand(blockId, NeoBlockType.SERVO_ANGLE_WAIT, [output, angle, speed]);
                }
              }
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_servo_rotate: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_servo_direction_f, 1], [Lang.Blocks.neo_servo_direction_b, 2]],
            value: 1,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '50',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, null, null],
            type: 'neo_servo_rotate'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            DIRECTION: 1,
            SPEED: 2
          },
          "class": 'neo_servo',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var direction = script.getStringField('DIRECTION');
              var speed = script.getStringField('SPEED');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              if (speed.indexOf('IN') >= 0) {
                _this.requestExtCommand(blockId, NeoBlockType.SERVO_ROTATE, [output, direction, speed]);
              } else {
                _this.requestCommand(blockId, NeoBlockType.SERVO_ROTATE, [output, direction, speed]);
              }
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_servo_stop: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_servo_stop'
          },
          paramsKeyMap: {
            OUTPUT: 0
          },
          "class": 'neo_servo',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.SERVO_STOP, [output]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * LED
         */
        neo_led_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_led_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_led_title'
          },
          "class": 'neo_led',
          isNotFor: ['neo'],
          events: {}
        },
        neo_led_on: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_led_brightness_100, '100'], [Lang.Blocks.neo_led_brightness_90, '90'], [Lang.Blocks.neo_led_brightness_80, '80'], [Lang.Blocks.neo_led_brightness_70, '70'], [Lang.Blocks.neo_led_brightness_60, '60'], [Lang.Blocks.neo_led_brightness_50, '50'], [Lang.Blocks.neo_led_brightness_40, '40'], [Lang.Blocks.neo_led_brightness_30, '30'], [Lang.Blocks.neo_led_brightness_20, '20'], [Lang.Blocks.neo_led_brightness_10, '10'], [Lang.Blocks.neo_led_brightness_0, '0'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '100',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, {
              type: 'neo_arg_duration'
            }, null],
            type: 'neo_led_on'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            BRIGHTNESS: 1,
            DURATION: 2
          },
          "class": 'neo_led',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var output = script.getStringField('OUTPUT');
              var brightness = script.getStringField('BRIGHTNESS');
              var duration = script.getStringValue('DURATION', script);
              var blockId = _this.generateBlockId();
              if (brightness.indexOf('IN') >= 0) {
                _this.requestExtCommand(blockId, NeoBlockType.LED_ON, [output, brightness]);
              } else {
                _this.requestCommand(blockId, NeoBlockType.LED_ON, [output, brightness]);
              }
              if (duration === 'c' || !Entry.parseNumber(duration)) {
                script.block_id = blockId;
                script.exec_phase = ExecPhase.PENDING_STOP;
              } else {
                script.exec_phase = ExecPhase.SET_TIMEOUT;
              }
            } else if (script.exec_phase === ExecPhase.SET_TIMEOUT) {
              var _duration5 = script.getStringValue('DURATION', script);
              var durationValue = Entry.parseNumber(_duration5);
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, durationValue * 1000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _output = script.getStringField('OUTPUT');
              var _blockId5 = _this.generateBlockId();
              script.block_id = _blockId5;
              _this.requestCommand(_blockId5, NeoBlockType.LED_ON, [_output, 0]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_led_blink: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_led_blink_speed_1, 500], [Lang.Blocks.neo_led_blink_speed_2, 400], [Lang.Blocks.neo_led_blink_speed_3, 300], [Lang.Blocks.neo_led_blink_speed_4, 200], [Lang.Blocks.neo_led_blink_speed_5, 100]],
            value: 100,
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, {
              type: 'neo_arg_duration'
            }, null],
            type: 'neo_led_blink'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            SPEED: 1,
            DURATION: 2
          },
          "class": 'neo_led',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var output = script.getStringField('OUTPUT');
              var speed = script.getStringField('SPEED');
              var duration = script.getStringValue('DURATION', script);
              var blockId = _this.generateBlockId();
              _this.requestCommand(blockId, NeoBlockType.LED_BLINK, [output, speed, 100]);
              if (duration === 'c' || !Entry.parseNumber(duration)) {
                script.exec_phase = ExecPhase.PENDING_STOP;
                script.block_id = blockId;
              } else {
                script.exec_phase = ExecPhase.SET_TIMEOUT;
              }
            } else if (script.exec_phase === ExecPhase.SET_TIMEOUT) {
              var _duration6 = script.getStringValue('DURATION', script);
              var durationValue = Entry.parseNumber(_duration6);
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, durationValue * 1000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _output2 = script.getStringField('OUTPUT');
              var _blockId6 = _this.generateBlockId();
              script.block_id = _blockId6;
              _this.requestCommand(_blockId6, NeoBlockType.LED_BLINK, [_output2, 0, 0]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_led_off: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_led_off'
          },
          paramsKeyMap: {
            OUTPUT: 0
          },
          "class": 'neo_led',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.LED_OFF, [output]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * 컬러 LED
         */
        neo_color_led_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_color_led_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_color_led_title'
          },
          "class": 'neo_color_led',
          isNotFor: ['neo'],
          events: {}
        },
        neo_color_led_on: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Color'
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, '#0000FF', {
              type: 'neo_arg_duration'
            }, null],
            type: 'neo_color_led_on'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            COLOR: 1,
            DURATION: 2
          },
          "class": 'neo_color_led',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var output = script.getStringField('OUTPUT');
              var color = script.getStringValue('COLOR', script);
              var duration = script.getStringValue('DURATION', script);
              var blockId = _this.generateBlockId();
              _this.requestCommand(blockId, NeoBlockType.COLOR_LED_ON, [output, color]);
              if (duration === 'c' || !Entry.parseNumber(duration)) {
                script.exec_phase = ExecPhase.PENDING_STOP;
                script.block_id = blockId;
              } else {
                script.exec_phase = ExecPhase.SET_TIMEOUT;
              }
            } else if (script.exec_phase === ExecPhase.SET_TIMEOUT) {
              var _duration7 = script.getStringValue('DURATION', script);
              var durationValue = Entry.parseNumber(_duration7);
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, durationValue * 1000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _output3 = script.getStringField('OUTPUT');
              var _blockId7 = _this.generateBlockId();
              script.block_id = _blockId7;
              _this.requestCommand(_blockId7, NeoBlockType.COLOR_LED_ON, [_output3, 0]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_color_led_off: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_color_led_off'
          },
          paramsKeyMap: {
            OUTPUT: 0
          },
          "class": 'neo_color_led',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.COLOR_LED_OFF, [output]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_color_led_on_with_sensor: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: 'IN1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, null],
            type: 'neo_color_led_on_with_sensor'
          },
          paramsKeyMap: {
            INPUT: 0,
            OUTPUT: 1
          },
          "class": 'neo_color_led',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var input = script.getStringField('INPUT');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestExtCommand(blockId, NeoBlockType.COLOR_LED_ON_SENSOR, [output, input]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * 출력
         */
        neo_set_output_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_set_output_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_set_output_title'
          },
          "class": 'neo_set_output',
          isNotFor: ['neo'],
          events: {}
        },
        neo_set_output: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3'], [Lang.Blocks.neo_output_12, 'OUT12'], [Lang.Blocks.neo_output_123, 'OUT123']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_set_output_value_255, '255'], [Lang.Blocks.neo_set_output_value_250, '250'], [Lang.Blocks.neo_set_output_value_245, '245'], [Lang.Blocks.neo_set_output_value_240, '240'], [Lang.Blocks.neo_set_output_value_235, '235'], [Lang.Blocks.neo_set_output_value_230, '230'], [Lang.Blocks.neo_set_output_value_225, '225'], [Lang.Blocks.neo_set_output_value_220, '220'], [Lang.Blocks.neo_set_output_value_215, '215'], [Lang.Blocks.neo_set_output_value_210, '210'], [Lang.Blocks.neo_set_output_value_205, '205'], [Lang.Blocks.neo_set_output_value_200, '200'], [Lang.Blocks.neo_set_output_value_195, '195'], [Lang.Blocks.neo_set_output_value_190, '190'], [Lang.Blocks.neo_set_output_value_185, '185'], [Lang.Blocks.neo_set_output_value_180, '180'], [Lang.Blocks.neo_set_output_value_175, '175'], [Lang.Blocks.neo_set_output_value_170, '170'], [Lang.Blocks.neo_set_output_value_165, '165'], [Lang.Blocks.neo_set_output_value_160, '160'], [Lang.Blocks.neo_set_output_value_155, '155'], [Lang.Blocks.neo_set_output_value_150, '150'], [Lang.Blocks.neo_set_output_value_145, '145'], [Lang.Blocks.neo_set_output_value_140, '140'], [Lang.Blocks.neo_set_output_value_135, '135'], [Lang.Blocks.neo_set_output_value_130, '130'], [Lang.Blocks.neo_set_output_value_125, '125'], [Lang.Blocks.neo_set_output_value_120, '120'], [Lang.Blocks.neo_set_output_value_115, '115'], [Lang.Blocks.neo_set_output_value_110, '110'], [Lang.Blocks.neo_set_output_value_105, '105'], [Lang.Blocks.neo_set_output_value_100, '100'], [Lang.Blocks.neo_set_output_value_95, '95'], [Lang.Blocks.neo_set_output_value_90, '90'], [Lang.Blocks.neo_set_output_value_85, '85'], [Lang.Blocks.neo_set_output_value_80, '80'], [Lang.Blocks.neo_set_output_value_75, '75'], [Lang.Blocks.neo_set_output_value_70, '70'], [Lang.Blocks.neo_set_output_value_65, '65'], [Lang.Blocks.neo_set_output_value_60, '60'], [Lang.Blocks.neo_set_output_value_55, '55'], [Lang.Blocks.neo_set_output_value_50, '50'], [Lang.Blocks.neo_set_output_value_45, '45'], [Lang.Blocks.neo_set_output_value_40, '40'], [Lang.Blocks.neo_set_output_value_35, '35'], [Lang.Blocks.neo_set_output_value_30, '30'], [Lang.Blocks.neo_set_output_value_25, '25'], [Lang.Blocks.neo_set_output_value_20, '20'], [Lang.Blocks.neo_set_output_value_15, '15'], [Lang.Blocks.neo_set_output_value_10, '10'], [Lang.Blocks.neo_set_output_value_5, '5'], [Lang.Blocks.neo_set_output_value_0, '0'], [Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: '100',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, {
              type: 'neo_arg_duration'
            }, null],
            type: 'neo_set_output'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            VALUE: 1,
            DURATION: 2
          },
          "class": 'neo_set_output',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var output = script.getStringField('OUTPUT');
              var value = script.getStringField('VALUE');
              var duration = script.getStringValue('DURATION', script);
              var blockId = _this.generateBlockId();
              if (value.indexOf('IN') >= 0) {
                _this.requestExtCommand(blockId, NeoBlockType.SET_OUTPUT, [output, value]);
              } else {
                _this.requestCommand(blockId, NeoBlockType.SET_OUTPUT, [output, value]);
              }
              if (duration === 'c' || !Entry.parseNumber(duration)) {
                script.exec_phase = ExecPhase.PENDING_STOP;
                script.block_id = blockId;
              } else {
                script.exec_phase = ExecPhase.SET_TIMEOUT;
              }
            } else if (script.exec_phase === ExecPhase.SET_TIMEOUT) {
              var _duration8 = script.getStringValue('DURATION', script);
              var durationValue = Entry.parseNumber(_duration8);
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, durationValue * 1000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _output4 = script.getStringField('OUTPUT');
              var _blockId8 = _this.generateBlockId();
              script.block_id = _blockId8;
              _this.requestCommand(_blockId8, NeoBlockType.SET_OUTPUT, [_output4, 0]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * 센서
         */
        neo_sensor_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_sensor_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_sensor_title'
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          events: {}
        },
        neo_sensor_in: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic_string_field',
          fontColor: '#fff',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [['IN1', 'IN1'], ['IN2', 'IN2'], ['IN3', 'IN3']],
            value: 'IN1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [null],
            type: 'neo_sensor_in'
          },
          paramsKeyMap: {
            INPUT: 0
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var input = script.getStringField('INPUT');
            var sensorData = Entry.hw.portData['sensor'];
            switch (input) {
              case 'IN1':
                return sensorData['in1Values'][0];
              case 'IN2':
                return sensorData['in2Values'][0];
              case 'IN3':
                return sensorData['in3Values'][0];
            }
            return 0;
          }
        },
        neo_sensor_in_2: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic_string_field',
          fontColor: '#fff',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [['IN1', 'IN1'], ['IN2', 'IN2'], ['IN3', 'IN3']],
            value: 'IN2',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [null],
            type: 'neo_sensor_in_2'
          },
          paramsKeyMap: {
            INPUT: 0
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var input = script.getStringField('INPUT');
            var sensorData = Entry.hw.portData['sensor'];
            switch (input) {
              case 'IN1':
                return sensorData['in1Values'][0];
              case 'IN2':
                return sensorData['in2Values'][0];
              case 'IN3':
                return sensorData['in3Values'][0];
            }
            return 0;
          }
        },
        neo_sensor_digital_in: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic_string_field',
          fontColor: '#fff',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [['IN1', 'IN1'], ['IN2', 'IN2'], ['IN3', 'IN3']],
            value: 'IN1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_sensor_in_digital_1, 0], [Lang.Blocks.neo_sensor_in_digital_2, 1], [Lang.Blocks.neo_sensor_in_digital_3, 2], [Lang.Blocks.neo_sensor_in_digital_4, 3]],
            value: '0',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [null],
            type: 'neo_sensor_digital_in'
          },
          paramsKeyMap: {
            INPUT: 0,
            INDEX: 1
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var input = script.getStringField('INPUT');
            var index = script.getNumberField('INDEX');
            var sensorData = Entry.hw.portData['sensor'];
            switch (input) {
              case 'IN1':
                return sensorData['in1Values'][index];
              case 'IN2':
                return sensorData['in2Values'][index];
              case 'IN3':
                return sensorData['in3Values'][index];
            }
            return 0;
          }
        },
        neo_sensor_convert: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic_string_field',
          fontColor: '#fff',
          statements: [],
          params: [{
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Block',
            accept: 'string'
          }, {
            type: 'Block',
            accept: 'string'
          }, {
            type: 'Block',
            accept: 'string'
          }, {
            type: 'Block',
            accept: 'string'
          }],
          events: {},
          def: {
            params: [{
              type: 'neo_sensor_in'
            }, {
              type: 'number',
              params: ['10']
            }, {
              type: 'number',
              params: ['255']
            }, {
              type: 'number',
              params: ['0']
            }, {
              type: 'number',
              params: ['100']
            }],
            type: 'neo_sensor_convert'
          },
          paramsKeyMap: {
            INPUT: 0,
            FROM_MIN: 1,
            FROM_MAX: 2,
            TO_MIN: 3,
            TO_MAX: 4
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var value = script.getNumberValue('INPUT', script);
            var fromMin = script.getNumberValue('FROM_MIN', script);
            var fromMax = script.getNumberValue('FROM_MAX', script);
            var toMin = script.getNumberValue('TO_MIN', script);
            var toMax = script.getNumberValue('TO_MAX', script);
            if (fromMin > fromMax) {
              var temp = fromMin;
              fromMin = fromMax;
              fromMax = temp;
            }
            if (toMin > toMax) {
              var _temp = toMin;
              toMin = toMax;
              toMax = _temp;
            }
            value -= fromMin;
            value = value * ((toMax - toMin) / (fromMax - fromMin));
            value += toMin;
            value = Math.min(toMax, value);
            value = Math.max(toMin, value);
            return Math.round(value);
          }
        },
        neo_sensor_compare: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          fontColor: '#ffffff',
          skeleton: 'basic_boolean_field',
          statements: [],
          params: [{
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_compare_gt, '>='], [Lang.Blocks.neo_compare_g, '>'], [Lang.Blocks.neo_compare_e, '='], [Lang.Blocks.neo_compare_l, '<'], [Lang.Blocks.neo_compare_lt, '<=']],
            value: '>',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string'
          }],
          events: {},
          def: {
            params: [{
              type: 'neo_sensor_in'
            }, null, 10],
            type: 'neo_sensor_compare'
          },
          paramsKeyMap: {
            INPUT: 0,
            SYMBOL: 1,
            VALUE: 2
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var input = script.getNumberValue('INPUT', script);
            var symbol = script.getStringField('SYMBOL');
            var value = script.getNumberValue('VALUE', script);
            var sensorValue = input;
            if (symbol === '=') {
              return sensorValue === value;
            } else if (symbol === '>') {
              return sensorValue > value;
            } else if (symbol === '<') {
              return sensorValue < value;
            } else if (symbol === '>=') {
              return sensorValue >= value;
            } else if (symbol === '<=') {
              return sensorValue <= value;
            }
            return false;
          }
        },
        neo_sensor_between: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          fontColor: '#ffffff',
          skeleton: 'basic_boolean_field',
          statements: [],
          params: [{
            type: 'Block',
            accept: 'string'
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_compare_gt, '>='], [Lang.Blocks.neo_compare_g, '>'], [Lang.Blocks.neo_compare_e, '='], [Lang.Blocks.neo_compare_l, '<'], [Lang.Blocks.neo_compare_lt, '<=']],
            value: '<',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_compare_gt, '>='], [Lang.Blocks.neo_compare_g, '>'], [Lang.Blocks.neo_compare_e, '='], [Lang.Blocks.neo_compare_l, '<'], [Lang.Blocks.neo_compare_lt, '<=']],
            value: '<',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string'
          }],
          events: {},
          def: {
            params: [10, null, {
              type: 'neo_sensor_in'
            }, null, 30],
            type: 'neo_sensor_between'
          },
          paramsKeyMap: {
            L_VALUE: 0,
            L_SYMBOL: 1,
            INPUT: 2,
            R_SYMBOL: 3,
            R_VALUE: 4
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var input = script.getNumberValue('INPUT', script);
            var lSymbol = script.getStringField('L_SYMBOL');
            var lValue = script.getNumberValue('L_VALUE', script);
            var rSymbol = script.getStringField('R_SYMBOL');
            var rValue = script.getNumberValue('R_VALUE', script);
            var sensorValue = input;
            var lResult = false;
            if (lSymbol === '=') {
              lResult = lValue === sensorValue;
            } else if (lSymbol === '>') {
              lResult = lValue > sensorValue;
            } else if (lSymbol === '<') {
              lResult = lValue < sensorValue;
            } else if (lSymbol === '>=') {
              lResult = lValue >= sensorValue;
            } else if (lSymbol === '<=') {
              lResult = lValue <= sensorValue;
            }
            var rResult = false;
            if (rSymbol === '=') {
              rResult = sensorValue === rValue;
            } else if (rSymbol === '>') {
              rResult = sensorValue > rValue;
            } else if (rSymbol === '<') {
              rResult = sensorValue < rValue;
            } else if (rSymbol === '>=') {
              rResult = sensorValue >= rValue;
            } else if (rSymbol === '<=') {
              rResult = sensorValue <= rValue;
            }
            return lResult && rResult;
          }
        },
        neo_sensor_digital_compare: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          fontColor: '#ffffff',
          skeleton: 'basic_boolean_field',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [['IN1', 'IN1'], ['IN2', 'IN2'], ['IN3', 'IN3']],
            value: 'IN1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_sensor_in_digital_1, 0], [Lang.Blocks.neo_sensor_in_digital_2, 1], [Lang.Blocks.neo_sensor_in_digital_3, 2], [Lang.Blocks.neo_sensor_in_digital_4, 3]],
            value: '0',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_compare_gt, '>='], [Lang.Blocks.neo_compare_g, '>'], [Lang.Blocks.neo_compare_e, '='], [Lang.Blocks.neo_compare_l, '<'], [Lang.Blocks.neo_compare_lt, '<=']],
            value: '>',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string'
          }],
          events: {},
          def: {
            params: [null, null, null, 10],
            type: 'neo_sensor_digital_compare'
          },
          paramsKeyMap: {
            INPUT: 0,
            INDEX: 1,
            SYMBOL: 2,
            VALUE: 3
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var input = script.getStringField('INPUT');
            var index = script.getNumberField('INDEX');
            var sensorData = Entry.hw.portData['sensor'];
            var symbol = script.getStringField('SYMBOL');
            var value = script.getNumberValue('VALUE', script);
            var sensorValue = 0;
            switch (input) {
              case 'IN1':
                sensorValue = sensorData['in1Values'][index];
                break;
              case 'IN2':
                sensorValue = sensorData['in2Values'][index];
                break;
              case 'IN3':
                sensorValue = sensorData['in3Values'][index];
                break;
            }
            if (symbol === '=') {
              return sensorValue === value;
            } else if (symbol === '>') {
              return sensorValue > value;
            } else if (symbol === '<') {
              return sensorValue < value;
            } else if (symbol === '>=') {
              return sensorValue >= value;
            } else if (symbol === '<=') {
              return sensorValue <= value;
            }
            return false;
          }
        },
        neo_sensor_color_compare: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          fontColor: '#ffffff',
          skeleton: 'basic_boolean_field',
          statements: [],
          params: [{
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_color_black, 1], [Lang.Blocks.neo_color_white, 2], [Lang.Blocks.neo_color_red, 3], [Lang.Blocks.neo_color_yellow, 4], [Lang.Blocks.neo_color_green, 5], [Lang.Blocks.neo_color_blue, 6]],
            value: '2',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [{
              type: 'neo_sensor_in_2'
            }, null],
            type: 'neo_sensor_color_compare'
          },
          paramsKeyMap: {
            INPUT: 0,
            COLOR: 1
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var input = script.getNumberValue('INPUT', script);
            var color = script.getNumberField('COLOR');
            var sensorValue = input;
            if (color === 1) {
              return 0 <= sensorValue && sensorValue <= 10;
            } else if (color === 2) {
              return 11 <= sensorValue && sensorValue <= 59;
            } else if (color === 3) {
              return 61 <= sensorValue && sensorValue <= 99;
            } else if (color === 4) {
              return 101 <= sensorValue && sensorValue <= 139;
            } else if (color === 5) {
              return 141 <= sensorValue && sensorValue <= 179;
            } else if (color === 6) {
              return 181 <= sensorValue && sensorValue <= 219;
            }
            return false;
          }
        },
        neo_sensor_color_sequence_compare: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          fontColor: '#ffffff',
          skeleton: 'basic_boolean_field',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [['IN1', 'IN1'], ['IN2', 'IN2'], ['IN3', 'IN3']],
            value: 'IN2',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_color_red, 3], [Lang.Blocks.neo_color_yellow, 4], [Lang.Blocks.neo_color_green, 5], [Lang.Blocks.neo_color_blue, 6]],
            value: '3',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_color_red, 3], [Lang.Blocks.neo_color_yellow, 4], [Lang.Blocks.neo_color_green, 5], [Lang.Blocks.neo_color_blue, 6]],
            value: '4',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_color_black, 1], [Lang.Blocks.neo_color_red, 3], [Lang.Blocks.neo_color_yellow, 4], [Lang.Blocks.neo_color_green, 5], [Lang.Blocks.neo_color_blue, 6]],
            value: '1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [null, null, null, null],
            type: 'neo_sensor_color_sequence_compare'
          },
          paramsKeyMap: {
            INPUT: 0,
            COLOR1: 1,
            COLOR2: 2,
            COLOR3: 3
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var input = script.getStringField('INPUT');
            var color1 = script.getNumberField('COLOR1');
            var color2 = script.getNumberField('COLOR2');
            var color3 = script.getNumberField('COLOR3');
            var sensorData = Entry.hw.portData['sensor'];
            var seq1 = 0;
            var seq2 = 0;
            var seq3 = 0;
            switch (input) {
              case 'IN1':
                seq1 = sensorData['in1Values'][1];
                seq2 = sensorData['in1Values'][2];
                seq3 = sensorData['in1Values'][3];
                break;
              case 'IN2':
                seq1 = sensorData['in2Values'][1];
                seq2 = sensorData['in2Values'][2];
                seq3 = sensorData['in2Values'][3];
                break;
              case 'IN3':
                seq1 = sensorData['in3Values'][1];
                seq2 = sensorData['in3Values'][2];
                seq3 = sensorData['in3Values'][3];
                break;
            }
            var compare1 = false;
            var compare2 = false;
            var compare3 = false;
            if (color1 === 3) compare1 = 61 <= seq1 && seq1 <= 99;else if (color1 === 4) compare1 = 101 <= seq1 && seq1 <= 139;else if (color1 === 5) compare1 = 141 <= seq1 && seq1 <= 179;else if (color1 === 6) compare1 = 181 <= seq1 && seq1 <= 219;
            if (color2 === 3) compare2 = 61 <= seq2 && seq2 <= 99;else if (color2 === 4) compare2 = 101 <= seq2 && seq2 <= 139;else if (color2 === 5) compare2 = 141 <= seq2 && seq2 <= 179;else if (color2 === 6) compare2 = 181 <= seq2 && seq2 <= 219;
            if (color3 === 1) compare3 = 0 <= seq3 && seq3 <= 10;else if (color3 === 3) compare3 = 61 <= seq3 && seq3 <= 99;else if (color3 === 4) compare3 = 101 <= seq3 && seq3 <= 139;else if (color3 === 5) compare3 = 141 <= seq3 && seq3 <= 179;else if (color3 === 6) compare3 = 181 <= seq3 && seq3 <= 219;
            return compare1 && compare2 && compare3;
          }
        },
        neo_sensor_button_pressed: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          fontColor: '#FFFFFF',
          skeleton: 'basic_boolean_field',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_button_1, '1'], [Lang.Blocks.neo_button_2, '2'], [Lang.Blocks.neo_button_3, '3'], [Lang.Blocks.neo_button_4, '4']],
            value: '1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_button_on, 'ON'], [Lang.Blocks.neo_button_off, 'OFF']],
            value: 'ON',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_sensor_button_pressed'
          },
          paramsKeyMap: {
            BUTTON: 0,
            PRESSED: 1
          },
          "class": 'neo_sensor',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            var button = script.getNumberField('BUTTON');
            var pressed = script.getStringField('PRESSED');
            var sensorData = Entry.hw.portData['sensor'];
            var value = sensorData['IR'];
            if (button === 1) {
              if (pressed === 'ON') return value === 10;else return value !== 10;
            } else if (button === 2) {
              if (pressed === 'ON') return value === 11;else return value !== 11;
            } else if (button === 3) {
              if (pressed === 'ON') return value === 12;else return value !== 12;
            } else if (button === 4) {
              if (pressed === 'ON') return value === 13;else return value !== 13;
            }
          }
        },
        /**
         * 버저
         */
        neo_buzzer_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_buzzer_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_buzzer_title'
          },
          "class": 'neo_buzzer',
          isNotFor: ['neo'],
          events: {}
        },
        neo_buzzer_start: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_buzzer_octave_1, '0'], [Lang.Blocks.neo_buzzer_octave_2, '1'], [Lang.Blocks.neo_buzzer_octave_3, '2'], [Lang.Blocks.neo_buzzer_octave_4, '3'], [Lang.Blocks.neo_buzzer_octave_5, '4'], [Lang.Blocks.neo_buzzer_octave_6, '5']],
            value: '2',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_buzzer_do, '1'], [Lang.Blocks.neo_buzzer_do_sharp, '2'], [Lang.Blocks.neo_buzzer_re, '3'], [Lang.Blocks.neo_buzzer_re_sharp, '4'], [Lang.Blocks.neo_buzzer_mi, '5'], [Lang.Blocks.neo_buzzer_fa, '6'], [Lang.Blocks.neo_buzzer_fa_sharp, '7'], [Lang.Blocks.neo_buzzer_sol, '8'], [Lang.Blocks.neo_buzzer_sol_sharp, '9'], [Lang.Blocks.neo_buzzer_la, '10'], [Lang.Blocks.neo_buzzer_la_sharp, '11'], [Lang.Blocks.neo_buzzer_ti, '12']],
            value: '1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_buzzer_whole_note, '1'], [Lang.Blocks.neo_buzzer_half_note, '2'], [Lang.Blocks.neo_buzzer_quarter_note, '4'], [Lang.Blocks.neo_buzzer_8th_note, '8']],
            value: '4',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, null, null],
            type: 'neo_buzzer_start'
          },
          paramsKeyMap: {
            OCTAVE: 0,
            NOTE: 1,
            DURATION: 2
          },
          "class": 'neo_buzzer',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              var octave = script.getNumberField('OCTAVE');
              var note = script.getNumberField('NOTE');
              var value = Math.min(note + 12 * octave, 72);
              var duration = script.getStringValue('DURATION', script);
              var blockId = _this.generateBlockId();
              _this.requestCommand(blockId, NeoBlockType.BUZZER_START, [value]);
              script.exec_phase = ExecPhase.WAIT_TIMEOUT;
              setTimeout(function () {
                script.exec_phase = ExecPhase.STOP;
              }, 1 / duration * 2000);
            } else if (script.exec_phase === ExecPhase.WAIT_TIMEOUT) {
              return script;
            } else if (script.exec_phase === ExecPhase.STOP) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var _blockId9 = _this.generateBlockId();
              script.block_id = _blockId9;
              _this.requestCommand(_blockId9, NeoBlockType.BUZZER_STOP, []);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_buzzer_with_sensor: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_input_1, 'IN1'], [Lang.Blocks.neo_input_2, 'IN2'], [Lang.Blocks.neo_input_3, 'IN3']],
            value: 'IN1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null],
            type: 'neo_buzzer_with_sensor'
          },
          paramsKeyMap: {
            INPUT: 0
          },
          "class": 'neo_buzzer',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var input = script.getStringField('INPUT');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestExtCommand(blockId, NeoBlockType.BUZZER_WITH_SENSOR, [input]);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_buzzer_stop: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null],
            type: 'neo_buzzer_stop'
          },
          paramsKeyMap: {},
          "class": 'neo_buzzer',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_STOP;
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.BUZZER_STOP, []);
            } else if (script.exec_phase === ExecPhase.PENDING_STOP) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * LCD
         */
        neo_lcd_title: {
          color: EntryStatic.colorSet.common.TRANSPARENT,
          fontColor: '#191970',
          skeleton: 'basic_text',
          skeletonOptions: {
            contentPos: {
              x: 5
            }
          },
          params: [{
            type: 'Text',
            text: Lang.template.neo_lcd_title,
            color: '#191970',
            align: 'left'
          }],
          def: {
            type: 'neo_lcd_title'
          },
          "class": 'neo_lcd',
          isNotFor: ['neo'],
          events: {}
        },
        neo_lcd_image: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_lcd_image_1, '1'], [Lang.Blocks.neo_lcd_image_2, '2'], [Lang.Blocks.neo_lcd_image_3, '3'], [Lang.Blocks.neo_lcd_image_4, '4'], [Lang.Blocks.neo_lcd_image_5, '5'], [Lang.Blocks.neo_lcd_image_6, '6'], [Lang.Blocks.neo_lcd_image_7, '7'], [Lang.Blocks.neo_lcd_image_8, '8'], [Lang.Blocks.neo_lcd_image_9, '9'], [Lang.Blocks.neo_lcd_image_10, '10'], [Lang.Blocks.neo_lcd_image_11, '11'], [Lang.Blocks.neo_lcd_image_12, '12'], [Lang.Blocks.neo_lcd_image_13, '13']],
            value: '1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, null, null],
            type: 'neo_lcd_image'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            IMAGE: 1
          },
          "class": 'neo_lcd',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var image = script.getStringField('IMAGE');
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.LCD_IMAGE, [output, image]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        neo_lcd_text: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_output_1, 'OUT1'], [Lang.Blocks.neo_output_2, 'OUT2'], [Lang.Blocks.neo_output_3, 'OUT3']],
            value: 'OUT1',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }, {
            type: 'Block',
            accept: 'string'
          }, {
            type: 'Indicator',
            img: 'block_icon/hardware_icon.svg',
            size: 12
          }],
          events: {},
          def: {
            params: [null, '안녕', null],
            type: 'neo_lcd_text'
          },
          paramsKeyMap: {
            OUTPUT: 0,
            TEXT: 1
          },
          "class": 'neo_lcd',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            if (!script.exec_phase) {
              script.exec_phase = ExecPhase.PENDING_RESPONSE;
              var output = script.getStringField('OUTPUT');
              var text = script.getStringValue('TEXT', script);
              var blockId = _this.generateBlockId();
              script.block_id = blockId;
              _this.requestCommand(blockId, NeoBlockType.LCD_TEXT, [output, text]);
            } else if (script.exec_phase === ExecPhase.PENDING_RESPONSE) {
              if (!_this.pendingResponseList[script.block_id]) {
                delete script.block_id;
                delete script.exec_phase;
                return script.callReturn();
              }
            }
            return script;
          }
        },
        /**
         * ARG Blocks
         */
        neo_arg_duration: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic_string_field',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_duration_c, 'c'], [Lang.Blocks.neo_duration_0, '0'], [Lang.Blocks.neo_duration_1, '1'], [Lang.Blocks.neo_duration_2, '2'], [Lang.Blocks.neo_duration_3, '3'], [Lang.Blocks.neo_duration_4, '4'], [Lang.Blocks.neo_duration_5, '5'], [Lang.Blocks.neo_duration_6, '6'], [Lang.Blocks.neo_duration_7, '7'], [Lang.Blocks.neo_duration_8, '8'], [Lang.Blocks.neo_duration_9, '9']],
            value: 'c',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [null]
          },
          paramsKeyMap: {
            VALUE: 0
          },
          "class": 'neo_arg',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            return script.getStringField('VALUE');
          }
        },
        neo_arg_both_motor_speed: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic_string_field',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_motor_speed_100, '100'], [Lang.Blocks.neo_motor_speed_95, '95'], [Lang.Blocks.neo_motor_speed_90, '90'], [Lang.Blocks.neo_motor_speed_85, '85'], [Lang.Blocks.neo_motor_speed_80, '80'], [Lang.Blocks.neo_motor_speed_75, '75'], [Lang.Blocks.neo_motor_speed_70, '70'], [Lang.Blocks.neo_motor_speed_65, '65'], [Lang.Blocks.neo_motor_speed_60, '60'], [Lang.Blocks.neo_motor_speed_55, '55'], [Lang.Blocks.neo_motor_speed_50, '50'], [Lang.Blocks.neo_motor_speed_45, '45'], [Lang.Blocks.neo_motor_speed_40, '40'], [Lang.Blocks.neo_motor_speed_35, '35'], [Lang.Blocks.neo_motor_speed_30, '30'], [Lang.Blocks.neo_motor_speed_25, '25'], [Lang.Blocks.neo_motor_speed_20, '20'], [Lang.Blocks.neo_motor_speed_15, '15'], [Lang.Blocks.neo_motor_speed_10, '10'], [Lang.Blocks.neo_motor_speed_5, '5'], [Lang.Blocks.neo_motor_speed_0, '0'], [Lang.Blocks.neo_motor_speed_n5, '-5'], [Lang.Blocks.neo_motor_speed_n10, '-10'], [Lang.Blocks.neo_motor_speed_n15, '-15'], [Lang.Blocks.neo_motor_speed_n20, '-20'], [Lang.Blocks.neo_motor_speed_n25, '-25'], [Lang.Blocks.neo_motor_speed_n30, '-30'], [Lang.Blocks.neo_motor_speed_n35, '-35'], [Lang.Blocks.neo_motor_speed_n40, '-40'], [Lang.Blocks.neo_motor_speed_n45, '-45'], [Lang.Blocks.neo_motor_speed_n50, '-50'], [Lang.Blocks.neo_motor_speed_n55, '-55'], [Lang.Blocks.neo_motor_speed_n60, '-60'], [Lang.Blocks.neo_motor_speed_n65, '-65'], [Lang.Blocks.neo_motor_speed_n70, '-70'], [Lang.Blocks.neo_motor_speed_n75, '-75'], [Lang.Blocks.neo_motor_speed_n80, '-80'], [Lang.Blocks.neo_motor_speed_n85, '-85'], [Lang.Blocks.neo_motor_speed_n90, '-90'], [Lang.Blocks.neo_motor_speed_n95, '-95'], [Lang.Blocks.neo_motor_speed_n100, '-100']],
            value: '100',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [null]
          },
          paramsKeyMap: {
            VALUE: 0
          },
          "class": 'neo_arg',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            return script.getStringField('VALUE');
          }
        },
        neo_arg_servo_angle: {
          color: EntryStatic.colorSet.block["default"].HARDWARE,
          outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
          skeleton: 'basic_string_field',
          statements: [],
          params: [{
            type: 'Dropdown',
            options: [[Lang.Blocks.neo_servo_angle_360, '360'], [Lang.Blocks.neo_servo_angle_350, '350'], [Lang.Blocks.neo_servo_angle_340, '340'], [Lang.Blocks.neo_servo_angle_330, '330'], [Lang.Blocks.neo_servo_angle_320, '320'], [Lang.Blocks.neo_servo_angle_310, '310'], [Lang.Blocks.neo_servo_angle_300, '300'], [Lang.Blocks.neo_servo_angle_290, '290'], [Lang.Blocks.neo_servo_angle_280, '280'], [Lang.Blocks.neo_servo_angle_270, '270'], [Lang.Blocks.neo_servo_angle_260, '260'], [Lang.Blocks.neo_servo_angle_250, '250'], [Lang.Blocks.neo_servo_angle_240, '240'], [Lang.Blocks.neo_servo_angle_230, '230'], [Lang.Blocks.neo_servo_angle_220, '220'], [Lang.Blocks.neo_servo_angle_210, '210'], [Lang.Blocks.neo_servo_angle_200, '200'], [Lang.Blocks.neo_servo_angle_190, '190'], [Lang.Blocks.neo_servo_angle_180, '180'], [Lang.Blocks.neo_servo_angle_170, '170'], [Lang.Blocks.neo_servo_angle_160, '160'], [Lang.Blocks.neo_servo_angle_150, '150'], [Lang.Blocks.neo_servo_angle_140, '140'], [Lang.Blocks.neo_servo_angle_130, '130'], [Lang.Blocks.neo_servo_angle_120, '120'], [Lang.Blocks.neo_servo_angle_110, '110'], [Lang.Blocks.neo_servo_angle_100, '100'], [Lang.Blocks.neo_servo_angle_90, '90'], [Lang.Blocks.neo_servo_angle_80, '80'], [Lang.Blocks.neo_servo_angle_70, '70'], [Lang.Blocks.neo_servo_angle_60, '60'], [Lang.Blocks.neo_servo_angle_50, '50'], [Lang.Blocks.neo_servo_angle_40, '40'], [Lang.Blocks.neo_servo_angle_30, '30'], [Lang.Blocks.neo_servo_angle_20, '20'], [Lang.Blocks.neo_servo_angle_10, '10'], [Lang.Blocks.neo_servo_angle_0, '0'], [Lang.Blocks.neo_servo_angle_n10, '-10'], [Lang.Blocks.neo_servo_angle_n20, '-20'], [Lang.Blocks.neo_servo_angle_n30, '-30'], [Lang.Blocks.neo_servo_angle_n40, '-40'], [Lang.Blocks.neo_servo_angle_n50, '-50'], [Lang.Blocks.neo_servo_angle_n60, '-60'], [Lang.Blocks.neo_servo_angle_n70, '-70'], [Lang.Blocks.neo_servo_angle_n80, '-80'], [Lang.Blocks.neo_servo_angle_n90, '-90'], [Lang.Blocks.neo_servo_angle_n100, '-100'], [Lang.Blocks.neo_servo_angle_n110, '-110'], [Lang.Blocks.neo_servo_angle_n120, '-120'], [Lang.Blocks.neo_servo_angle_n130, '-130'], [Lang.Blocks.neo_servo_angle_n140, '-140'], [Lang.Blocks.neo_servo_angle_n150, '-150'], [Lang.Blocks.neo_servo_angle_n160, '-160'], [Lang.Blocks.neo_servo_angle_n170, '-170'], [Lang.Blocks.neo_servo_angle_n180, '-180'], [Lang.Blocks.neo_servo_angle_n190, '-190'], [Lang.Blocks.neo_servo_angle_n200, '-200'], [Lang.Blocks.neo_servo_angle_n210, '-210'], [Lang.Blocks.neo_servo_angle_n220, '-220'], [Lang.Blocks.neo_servo_angle_n230, '-230'], [Lang.Blocks.neo_servo_angle_n240, '-240'], [Lang.Blocks.neo_servo_angle_n250, '-250'], [Lang.Blocks.neo_servo_angle_n260, '-260'], [Lang.Blocks.neo_servo_angle_n270, '-270'], [Lang.Blocks.neo_servo_angle_n280, '-280'], [Lang.Blocks.neo_servo_angle_n290, '-290'], [Lang.Blocks.neo_servo_angle_n300, '-300'], [Lang.Blocks.neo_servo_angle_n310, '-310'], [Lang.Blocks.neo_servo_angle_n320, '-320'], [Lang.Blocks.neo_servo_angle_n330, '-330'], [Lang.Blocks.neo_servo_angle_n340, '-340'], [Lang.Blocks.neo_servo_angle_n350, '-350'], [Lang.Blocks.neo_servo_angle_n360, '-360']],
            value: '100',
            fontSize: 11,
            bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
            arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
          }],
          events: {},
          def: {
            params: [null]
          },
          paramsKeyMap: {
            VALUE: 0
          },
          "class": 'neo_arg',
          isNotFor: ['neo'],
          func: function func(sprite, script) {
            return script.getStringField('VALUE');
          }
        }
      };
    }
  }, {
    key: "getCheckSum",
    value: function getCheckSum(command) {
      var checkSum = 0;
      for (var i = 0; i < command.length; i++) {
        checkSum += command[i];
      }
      return checkSum & 255;
    }
  }, {
    key: "getUnitId",
    value: function getUnitId(port) {
      switch (port) {
        case 'OUT1':
          return UnitId.CONTROLLER_OUT1;
        case 'OUT2':
          return UnitId.CONTROLLER_OUT2;
        case 'OUT3':
          return UnitId.CONTROLLER_OUT3;
        case 'OUT12':
          return UnitId.CONTROLLER_OUT12;
        case 'OUT123':
          return UnitId.CONTROLLER_OUT_ALL;
        case 'IN1':
          return UnitId.CONTROLLER_IN1;
        case 'IN2':
          return UnitId.CONTROLLER_IN2;
        case 'IN3':
          return UnitId.CONTROLLER_IN3;
      }
      return UnitId.CONTROLLER;
    }
  }, {
    key: "makePdu",
    value: function makePdu(command) {
      var pdu = [];
      pdu.push.apply(pdu, HEADER);
      pdu.push(command.length);
      pdu.push.apply(pdu, (0, _toConsumableArray2["default"])(command));
      pdu.push(this.getCheckSum(command));
      return pdu;
    }
  }, {
    key: "requestCommand",
    value: function requestCommand(blockId, type, params) {
      // console.log(blockId + ' requested');
      if (this.pendingResponseList[blockId]) {
        delete this.pendingResponseList[blockId];
      }
      this.pendingResponseList[blockId] = 'executed';
      var command = this.makeCommand(blockId, type, params);
      if (!command) return;
      var pdu = this.makePdu(command);
      this.executeList[blockId] = {
        blockId: blockId,
        pdu: pdu
      };
      Entry.hw.sendQueue.executeList = _objectSpread({}, this.executeList);
      Entry.hw.update();
    }
  }, {
    key: "requestExt2Command",
    value: function requestExt2Command(blockId, type, params) {
      // console.log(blockId + ' requested');
      if (this.pendingResponseList[blockId]) {
        delete this.pendingResponseList[blockId];
      }
      this.pendingResponseList[blockId] = 'executed';
      var command = this.makeCommandExt2(blockId, type, params);
      if (!command) return;
      var pdu = this.makePdu(command);
      this.executeList[blockId] = {
        blockId: blockId,
        pdu: pdu
      };
      Entry.hw.sendQueue.executeList = _objectSpread({}, this.executeList);
      Entry.hw.update();
    }
  }, {
    key: "requestExtCommand",
    value: function requestExtCommand(blockId, type, params) {
      // console.log(blockId + ' requested');
      if (this.pendingResponseList[blockId]) {
        delete this.pendingResponseList[blockId];
      }
      this.pendingResponseList[blockId] = 'executed';
      var command = this.makeCommandExt(blockId, type, params);
      if (!command) return;
      var pdu = this.makePdu(command);
      this.executeList[blockId] = {
        blockId: blockId,
        pdu: pdu
      };
      Entry.hw.sendQueue.executeList = _objectSpread({}, this.executeList);
      Entry.hw.update();
    }
  }, {
    key: "makeCommand",
    value: function makeCommand(blockId, type, params) {
      //const body = [FrameCode.BASIC, PduCode.ACTION_COMMAND, PduType.REQUEST];
      var body = [FrameCode.BASIC, PduCode.BASIC, blockId];
      if (type === NeoBlockType.MOTOR_MOVE) {
        var which = params[0];
        var speed = Math.abs(params[1]);
        var direction = params[1] < 0 ? 1 : 0;
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.MOTOR);
        var data = Buffer.from([0, 0, 0, 0, 0, 0]);
        data.writeInt16LE(speed, 0);
        data.writeInt16LE(which, 2);
        data.writeInt16LE(direction, 4);
        body.push.apply(body, (0, _toConsumableArray2["default"])(data));
      } else if (type === NeoBlockType.MOTOR_MOVE_BOTH) {
        var speedL = params[0];
        var speedR = params[1];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.MOTOR_BOTH);
        var _data = Buffer.from([0, 0, 0, 0]);
        _data.writeInt16LE(speedL, 0);
        _data.writeInt16LE(speedR, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data));
      } else if (type === NeoBlockType.ROBOT_MOVE) {
        var robotCommand = params[0];
        var _speed = params[1];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.ROBOT);
        var _data2 = Buffer.from([0, 0, 0, 0]);
        _data2.writeInt16LE(_speed, 0);
        _data2.writeInt16LE(robotCommand, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data2));
      } else if (type === NeoBlockType.MOTOR_STOP || type === NeoBlockType.AUTO_DRIVING_STOP) {
        var _which = params[0];
        var _direction2 = 1;
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.MOTOR);
        var _data3 = Buffer.from([0, 0, 0, 0, 0, 0]);
        _data3.writeInt16LE(_which, 2);
        _data3.writeInt16LE(_direction2, 4);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data3));
      } else if (type === NeoBlockType.ROBOT_STOP) {
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.ROBOT);
        var _data4 = Buffer.from([0, 0, 0, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data4));
      } else if (type === NeoBlockType.SERVO_RESET) {
        var output = params[0];
        body.push(this.getUnitId(output), ActorKind.SERVO, ServoCommand.RESET);
        var _data5 = Buffer.from([0, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data5));
      } else if (type === NeoBlockType.SERVO_ANGLE) {
        var _output5 = params[0];
        var angle = params[1];
        var _speed2 = params[2];
        body.push(this.getUnitId(_output5), ActorKind.SERVO, ServoCommand.ANGLE);
        var _data6 = Buffer.from([0, 0, 0, 0, 1, 0]);
        _data6.writeInt16LE(angle, 0);
        _data6.writeInt16LE(_speed2, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data6));
      } else if (type === NeoBlockType.SERVO_ANGLE_WAIT) {
        var _output6 = params[0];
        var _angle = params[1];
        var _speed3 = params[2];
        body.push(this.getUnitId(_output6), ActorKind.SERVO, ServoCommand.ANGLE_WAIT);
        var _data7 = Buffer.from([0, 0, 0, 0, 1, 0]);
        _data7.writeInt16LE(_angle, 0);
        _data7.writeInt16LE(_speed3, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data7));
      } else if (type === NeoBlockType.SERVO_ROTATE) {
        var _output7 = params[0];
        var _direction3 = params[1];
        var _speed4 = params[2];
        body.push(this.getUnitId(_output7), ActorKind.SERVO, ServoCommand.ROTATE);
        var _data8 = Buffer.from([0, 0, 0, 0]);
        _data8.writeInt16LE(_speed4, 0);
        _data8.writeInt16LE(_direction3, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data8));
      } else if (type === NeoBlockType.SERVO_STOP) {
        var _output8 = params[0];
        body.push(this.getUnitId(_output8), ActorKind.SERVO, ServoCommand.STOP);
      } else if (type === NeoBlockType.LINE_TRACER_START || type === NeoBlockType.AUTO_DRIVING_START || type === NeoBlockType.AUTO_DETECT_WALL_START) {
        var _speed5 = params[0];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.ROBOT);
        var _data9 = Buffer.from([0, 0, 0x10, 0]);
        _data9.writeInt16LE(_speed5, 0);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data9));
      } else if (type === NeoBlockType.AUTO_DRIVING_SENSOR_START) {
        var sensor = params[0];
        var _speed6 = params[1];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.ROBOT);
        var _data0 = Buffer.from([0, 0, 0, 0]);
        _data0.writeInt16LE(_speed6, 0);
        _data0.writeInt16LE(sensor, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data0));
      } else if (type === NeoBlockType.LINE_CROSS_MOVE) {
        var count = params[0];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.LINE_TRACER);
        var _data1 = Buffer.from([0, 0]);
        _data1.writeInt16LE(count, 0);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data1));
      } else if (type === NeoBlockType.LINE_CROSS_TURN) {
        var _direction4 = params[0];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.LINE_TRACER);
        var _data10 = Buffer.from([0, 0]);
        _data10.writeInt16LE(_direction4, 0);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data10));
      } else if (type === NeoBlockType.AUTO_PARKING_START) {
        // TODO : which 누락
        var _which2 = params[0];
        var _direction5 = params[1];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.AUTO_PARKING);
        var _data11 = Buffer.from([0, 0]);
        _data11.writeInt16LE(_direction5, 0);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data11));
      } else if (type === NeoBlockType.LINE_CHANGE_START) {
        var _direction6 = params[0];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.AUTO_DRIVING);
        var _data12 = Buffer.from([0, 0, 0, 0]);
        _data12.writeInt16LE(60, 0);
        _data12.writeInt16LE(_direction6, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data12));
      } else if (type === NeoBlockType.LINE_CHANGE_TURN) {
        var _direction7 = params[0];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.AUTO_DRIVING);
        var _data13 = Buffer.from([0, 0, 0, 0]);
        _data13.writeInt16LE(60, 0);
        _data13.writeInt16LE(_direction7, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data13));
      } else if (type === NeoBlockType.AUTO_DETECT_WALL_TURN) {
        var _direction8 = params[0];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.AUTO_DETECT_WALL);
        var _data14 = Buffer.from([0, 0, 0, 0]);
        _data14.writeInt16LE(60, 0);
        _data14.writeInt16LE(_direction8, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data14));
      } else if (type === NeoBlockType.LED_ON) {
        var _output9 = params[0];
        var brightness = params[1];
        body.push(this.getUnitId(_output9), ActorKind.LED, 0);
        var _data15 = Buffer.from([0, 0, 0, 0]);
        _data15.writeInt16LE(brightness, 0);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data15));
      } else if (type === NeoBlockType.LED_BLINK) {
        var _output0 = params[0];
        var _speed7 = params[1];
        var _brightness = params[2];
        body.push(this.getUnitId(_output0), ActorKind.LED, 0);
        var _data16 = Buffer.from([0, 0, 0, 0]);
        _data16.writeInt16LE(_brightness, 0);
        _data16.writeInt16LE(_speed7, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data16));
      } else if (type === NeoBlockType.LED_OFF) {
        var _output1 = params[0];
        body.push(this.getUnitId(_output1), ActorKind.LED, 0);
        var _data17 = Buffer.from([0, 0, 0, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data17));
      } else if (type === NeoBlockType.COLOR_LED_ON) {
        var _output10 = params[0];
        body.push(this.getUnitId(_output10), ActorKind.COLOR_LED, LedCommand.ON);
        var _data18 = Buffer.from([0, 0, 0, 0, 0, 0]);
        var color = params[1];
        if (color.length === 7 && color[0] === '#') {
          var r = color.substr(1, 2);
          var g = color.substr(3, 2);
          var b = color.substr(5, 2);
          _data18.writeInt16LE(parseInt(r, 16), 0);
          _data18.writeInt16LE(parseInt(g, 16), 2);
          _data18.writeInt16LE(parseInt(b, 16), 4);
        }
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data18));
      } else if (type === NeoBlockType.COLOR_LED_OFF) {
        var _output11 = params[0];
        body.push(this.getUnitId(_output11), ActorKind.COLOR_LED, LedCommand.OFF);
      } else if (type === NeoBlockType.SET_OUTPUT) {
        var _output12 = params[0];
        var value = params[1];
        body.push(this.getUnitId(_output12), ActorKind.LED, 0);
        var _data19 = Buffer.from([0, 0, 0, 0]);
        _data19.writeInt16LE(value, 0);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data19));
      } else if (type === NeoBlockType.BUZZER_START) {
        var _value = params[0];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.BUZZER);
        var _data20 = Buffer.from([0, 0]);
        _data20.writeInt16LE(_value, 0);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data20));
      } else if (type === NeoBlockType.BUZZER_STOP) {
        var _value2 = params[0];
        body.push(UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.BUZZER);
        var _data21 = Buffer.from([0, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data21));
      } else if (type === NeoBlockType.LCD_IMAGE) {
        var _output13 = this.getUnitId(params[0]);
        var _value3 = params[1];
        body.push(_output13, ActorKind.LCD, LcdCommand.IMAGE);
        var _data22 = Buffer.from([_value3, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data22));
      } else if (type === NeoBlockType.LCD_TEXT) {
        var _output14 = this.getUnitId(params[0]);
        var _value4 = params[1];
        body.push(_output14, ActorKind.LCD, LcdCommand.TEXT);
        body.push(0); // 글씨크기 : 지금 안됨.
        if (_value4.length > 0) {
          for (var idx = 0; idx < _value4.length; idx++) {
            body.push(_value4.charCodeAt(idx));
          }
        }
      }
      return body;
    }
  }, {
    key: "makeCommandExt",
    value: function makeCommandExt(blockId, type, params) {
      var body = [FrameCode.BASIC];
      if (type === NeoBlockType.MOTOR_MOVE) {
        var which = params[0];
        var unitId = this.getUnitId(params[1]);
        body.push(PduCode.EXTEND_1, blockId, UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.MOTOR);
        var data = Buffer.from([unitId, 0, which, 0, 0, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(data));
      } else if (type === NeoBlockType.ROBOT_MOVE) {
        var robotCommand = params[0];
        var _unitId = this.getUnitId(params[1]);
        body.push(PduCode.EXTEND_1, blockId, UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.ROBOT);
        var _data23 = Buffer.from([_unitId, 0, 0, 0]);
        _data23.writeInt16LE(robotCommand, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data23));
      } else if (type === NeoBlockType.SERVO_ANGLE || type === NeoBlockType.SERVO_ANGLE_WAIT) {
        var _unitId2 = this.getUnitId(params[0]);
        var angle = params[1];
        var speed = params[2];
        if (angle.indexOf('IN') >= 0) angle = this.getUnitId(angle);
        body.push(PduCode.EXTEND_1, blockId, _unitId2, ActorKind.SERVO, ServoCommand.ANGLE);
        var _data24 = Buffer.from([angle, 0, 0, 0, 1, 0]);
        _data24.writeInt16LE(speed, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data24));
      } else if (type === NeoBlockType.SERVO_ROTATE) {
        var _unitId3 = this.getUnitId(params[0]);
        var direction = params[1];
        var inUnitId = this.getUnitId(params[2]);
        body.push(PduCode.EXTEND_1, blockId, _unitId3, ActorKind.SERVO, ServoCommand.ROTATE);
        var _data25 = Buffer.from([inUnitId, 0, 0, 0]);
        _data25.writeInt16LE(direction, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data25));
      } else if (type === NeoBlockType.LINE_TRACER_START || type === NeoBlockType.AUTO_DRIVING_START || type === NeoBlockType.AUTO_DETECT_WALL_START) {
        var _unitId4 = this.getUnitId(params[0]);
        body.push(PduCode.EXTEND_1, blockId, UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.ROBOT);
        var _data26 = Buffer.from([_unitId4, 0, 0x10, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data26));
      } else if (type === NeoBlockType.AUTO_DRIVING_SENSOR_START) {
        var sensor = params[0];
        var _unitId5 = this.getUnitId(params[1]);
        body.push(PduCode.EXTEND_1, blockId, UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.ROBOT);
        var _data27 = Buffer.from([0, 0, 0, 0]);
        _data27.writeInt16LE(_unitId5, 0);
        _data27.writeInt16LE(sensor, 2);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data27));
      } else if (type === NeoBlockType.LED_ON) {
        var _unitId6 = this.getUnitId(params[0]);
        var _inUnitId = this.getUnitId(params[1]);
        body.push(PduCode.EXTEND_1, blockId, _unitId6, ActorKind.LED, 0);
        var _data28 = Buffer.from([_inUnitId, 0, 0, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data28));
      } else if (type === NeoBlockType.SET_OUTPUT) {
        var _unitId7 = this.getUnitId(params[0]);
        var _inUnitId2 = this.getUnitId(params[1]);
        body.push(PduCode.EXTEND_1, blockId, _unitId7, ActorKind.LED, 0);
        var _data29 = Buffer.from([_inUnitId2, 0, 0, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data29));
      } else if (type === NeoBlockType.BUZZER_WITH_SENSOR) {
        var sensorUnitId = this.getUnitId(params[0]);
        body.push(PduCode.EXTEND_1, blockId, UnitId.CONTROLLER, ActorKind.CONTROLLER, ControllerCommand.BUZZER);
        var _data30 = Buffer.from([0, 0]);
        _data30.writeInt16LE(sensorUnitId, 0);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data30));
      } else if (type === NeoBlockType.COLOR_LED_ON_SENSOR) {
        var outUnitId = this.getUnitId(params[0]);
        var _inUnitId3 = this.getUnitId(params[1]);
        body.push(PduCode.EXTEND_3, blockId, outUnitId, ActorKind.COLOR_LED, LedCommand.ON);
        var _data31 = Buffer.from([_inUnitId3, 1, _inUnitId3, 2, _inUnitId3, 3]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(_data31));
      }
      return body;
    }
  }, {
    key: "makeCommandExt2",
    value: function makeCommandExt2(blockId, type, params) {
      var body = [FrameCode.BASIC];
      if (type === NeoBlockType.SERVO_ANGLE || type === NeoBlockType.SERVO_ANGLE_WAIT) {
        var unitId = this.getUnitId(params[0]);
        var angleInUnitId = this.getUnitId(params[1]);
        var speedInUnitId = this.getUnitId(params[2]);
        body.push(PduCode.EXTEND_2, blockId, unitId, ActorKind.SERVO, ServoCommand.ANGLE);
        var data = Buffer.from([angleInUnitId, 0, speedInUnitId, 0, 1, 0]);
        body.push.apply(body, (0, _toConsumableArray2["default"])(data));
      }
      return body;
    }
    /*
      후면주차 실행 (pending response 하지 않고 바로 다음 단계로 넘어감 : phase 가 너무 많아서 간소화)
      주석은 왼쪽 기준으로 오른쪽에서는 좌우만 바꿔준다.
     */
  }, {
    key: "runAutoParking",
    value: (function () {
      var _runAutoParking = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(script) {
        var type, side, which;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              type = script.getNumberValue('DIRECTION', script);
              side = script.getNumberValue('WHICH', script);
              which = 0;
              if (!(type === 1)) {
                _context.next = 6;
                break;
              }
              // 후면주차
              this.requestCommand(this.generateBlockId(), NeoBlockType.LINE_TRACER_START, [40]);
              _context.next = 1;
              return Entry.Utils.sleep(2400);
            case 1:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              which = side === 1 ? 1 : 2;
              this.requestCommand(this.generateBlockId(), NeoBlockType.MOTOR_MOVE, [which, 30]);
              _context.next = 2;
              return Entry.Utils.sleep(2000);
            case 2:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_MOVE, [2, 25]);
              _context.next = 3;
              return Entry.Utils.sleep(2500);
            case 3:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              which = side === 1 ? 2 : 1;
              this.requestCommand(this.generateBlockId(), NeoBlockType.MOTOR_MOVE, [which, -30]);
              _context.next = 4;
              return Entry.Utils.sleep(1300);
            case 4:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_MOVE, [2, 25]);
              _context.next = 5;
              return Entry.Utils.sleep(1700);
            case 5:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              _context.next = 13;
              break;
            case 6:
              // 평행주차
              this.requestCommand(this.generateBlockId(), NeoBlockType.LINE_TRACER_START, [40]);
              _context.next = 7;
              return Entry.Utils.sleep(3000);
            case 7:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              which = side === 1 ? 1 : 2;
              this.requestCommand(this.generateBlockId(), NeoBlockType.MOTOR_MOVE, [which, 30]);
              _context.next = 8;
              return Entry.Utils.sleep(2000);
            case 8:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_MOVE, [2, 30]);
              _context.next = 9;
              return Entry.Utils.sleep(3000);
            case 9:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              which = side === 1 ? 1 : 2;
              this.requestCommand(this.generateBlockId(), NeoBlockType.MOTOR_MOVE, [which, -30]);
              _context.next = 10;
              return Entry.Utils.sleep(1000);
            case 10:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              which = side === 1 ? 2 : 1;
              this.requestCommand(this.generateBlockId(), NeoBlockType.MOTOR_MOVE, [which, 25]);
              _context.next = 11;
              return Entry.Utils.sleep(1000);
            case 11:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_MOVE, [2, 20]);
              _context.next = 12;
              return Entry.Utils.sleep(1000);
            case 12:
              this.requestCommand(this.generateBlockId(), NeoBlockType.ROBOT_STOP, [0]);
            case 13:
              return _context.abrupt("return", script.callReturn());
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function runAutoParking(_x) {
        return _runAutoParking.apply(this, arguments);
      }
      return runAutoParking;
    }())
  }]);
}())();
module.exports = Entry.Neo;